<template>
  <svg
    id="milestone-netlifycms"
    xmlns="http://www.w3.org/2000/svg"
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="500"
    height="380"
    viewBox="0 0 336.7 274.4"
    role="presentation"
    aria-labelledby="launchofcms"
  >
    <title id="launchofcms">Netlify CMS, a git-based CMS launches</title>
    <g id="ElementsBehind">
      <g id="drawnlinescms">
        <polyline
          ref="drawn1"
          class="cls-1 drawcms"
          points="335.4 179.6 308.9 165.9 296.2 141.6 279 133.4 266.2 109.8 260.5 113.9 234.8 99 220.3 107.3 176.9 82.2"
        />
        <polyline
          class="cls-1 drawcms"
          points="266.2 109.8 296.5 90.6 284.8 68 253.4 51.6 243.7 54.9 230.3 47 216.7 59.1 196.4 47.3 187.9 52.2 179.6 47.4"
        />
        <polyline class="cls-1 drawcms" points="274.9 104.2 266 89 238.1 71.9 228.5 80 210.3 67.5" />
        <polyline
          class="cls-1 drawcms"
          points="333.7 123.1 307.5 109.8 284.8 68 253.4 51.6 243.7 54.9 230.3 47 213.8 37.7 198.4 11.2 180.6 0.9"
        />
        <polyline
          class="cls-1 drawcms"
          points="333.8 65.8 316.8 57.7 301.4 64.3 274.3 48.6 263.6 56.9 253.4 51.6 243.7 54.9 177.5 16.8"
        />
      </g>
      <g id="_0202" data-name="0202">
        <g id="_02020202" data-name="02020202">
          <path
            id="Vector_2"
            data-name="Vector 2"
            class="cls-2"
            d="M282.4,38.1v1.4a1,1,0,0,1-1.6.9l-6.7-3.8a1.3,1.3,0,0,1-.6-.9V34.3a1,1,0,0,1,1.6-.9l6.7,3.8A1,1,0,0,1,282.4,38.1Z"
            transform="translate(-0.5 -2.3)"
          />
        </g>
        <g id="_01010101" data-name="01010101">
          <path
            id="Vector_3"
            data-name="Vector 3"
            class="cls-2"
            d="M303.5,57.2v1.4a1,1,0,0,1-1.6.9l-27.8-16a1.3,1.3,0,0,1-.6-.9V41.2a1,1,0,0,1,1.6-.9l27.8,16A1.1,1.1,0,0,1,303.5,57.2Z"
            transform="translate(-0.5 -2.3)"
          />
        </g>
      </g>
      <g id="_0101" data-name="0101">
        <g id="_020202" data-name="020202">
          <path
            id="Vector_4"
            data-name="Vector 4"
            class="cls-2"
            d="M226,30.8v1.4a1,1,0,0,1-1.6.9l-6.7-3.8a1.3,1.3,0,0,1-.6-.9V27a1,1,0,0,1,1.6-.9l6.7,3.8A1,1,0,0,1,226,30.8Z"
            transform="translate(-0.5 -2.3)"
          />
        </g>
        <g id="_010101" data-name="010101">
          <path
            id="Vector_5"
            data-name="Vector 5"
            class="cls-2"
            d="M247.1,49.9v1.4a1,1,0,0,1-1.6.9l-27.8-16a1.3,1.3,0,0,1-.6-.9V34a1,1,0,0,1,1.6-.9l27.8,16C246.9,49.1,247.1,49.5,247.1,49.9Z"
            transform="translate(-0.5 -2.3)"
          />
        </g>
      </g>
    </g>
    <g id="Computer">
      <g id="CircleGroupBelow" class="cls-3">
        <g id="Vector_6" data-name="Vector 6" class="cls-3">
          <path
            class="cls-4"
            d="M232.4,264.9c.2.2.2.5-.1.6a1.7,1.7,0,0,1-1,0c-.2-.2-.2-.5.1-.6A.9.9,0,0,1,232.4,264.9Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M229.1,266.5c.2.2.2.5-.1.6h-1c-.2-.2-.2-.5.1-.6A1.2,1.2,0,0,1,229.1,266.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M225.7,268c.2.2.1.5-.2.6h-1c-.2-.2-.1-.5.2-.6A1.7,1.7,0,0,1,225.7,268Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M222,269.5c.2.2.1.5-.2.6a1,1,0,0,1-.9-.1h-.1c-.2-.2-.1-.5.2-.6a1,1,0,0,1,1,.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M218.2,270.7c.2.2.1.5-.3.6a1.1,1.1,0,0,1-.8-.1H217c-.2-.2,0-.5.3-.6a1,1,0,0,1,.8.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M214.3,271.9a.4.4,0,0,1-.3.6,1.1,1.1,0,0,1-.8-.1h-.1a.4.4,0,0,1,.3-.6,1.1,1.1,0,0,1,.8.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M210.3,272.9c.1.2,0,.5-.5.6a1.1,1.1,0,0,1-.8-.1h-.1c-.1-.2,0-.5.5-.6h.9Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M253.4,247c-.1.2-.6.3-.9.2h-.2c-.2-.1-.2-.2-.2-.5s.6-.3.9-.2h.3C253.4,246.6,253.6,246.8,253.4,247Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M206.2,273.7c.1.2-.1.5-.5.6H205l-.2-.2c-.1-.2.1-.5.5-.6h.7C206,273.6,206.2,273.6,206.2,273.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M254.7,244.5c-.1.2-.5.3-.9.3h-.3c-.2-.1-.2-.2-.2-.5s.5-.3.9-.3h.3C254.6,244.2,254.7,244.3,254.7,244.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M202,274.4c.1.2-.1.5-.6.5h-.7l-.2-.2c-.1-.2.1-.5.6-.6h.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M255.4,241.6l.2.3c-.1.2-.5.3-.9.3h-.3l-.2-.3c.1-.2.5-.3.9-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M197.7,275c.1.2-.2.5-.6.5h-.7l-.2-.2c-.1-.2.2-.5.6-.5h.7C197.7,274.9,197.7,274.9,197.7,275Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M256.2,239.1l.2.3c0,.2-.5.3-.8.3h-.5l-.2-.3c.1-.2.5-.3.8-.3S256.1,239.1,256.2,239.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M193.4,275.4a.6.6,0,0,1-.6.5h-.6l-.2-.2c-.1-.2.2-.5.6-.5h.6A.2.2,0,0,1,193.4,275.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M256.7,236.5c.1.1.2.2.2.3s-.3.5-.8.3h-.5c-.1-.1-.2-.2-.2-.3s.3-.5.8-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M188.8,275.4c.1.1.2.1.2.2s-.2.5-.7.5h-.6l-.2-.2c0-.2.2-.5.7-.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M256.9,234c.1.1.2.2.2.3a.7.7,0,0,1-.7.5h-.5l-.2-.3a.7.7,0,0,1,.7-.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M184.5,275.4l.2.3a.7.7,0,0,1-.7.5h-.6l-.2-.3a.7.7,0,0,1,.7-.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M256.8,231.5l.2.2a.7.7,0,0,1-.7.5h-.6l-.2-.2a.7.7,0,0,1,.7-.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M180.1,275.4l.2.3c0,.2-.3.5-.8.3H179l-.2-.3c0-.2.3-.5.8-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M256.7,229.2c0,.2-.2.5-.7.5h-.6l-.2-.2c0-.2.2-.5.7-.5h.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M175.8,275.2c.1.1.2.2.2.3s-.5.3-.8.3h-.5c-.1-.1-.2-.2-.2-.3s.5-.5.8-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M256.1,226.7c.1.2-.2.5-.6.5h-.7l-.2-.2a.6.6,0,0,1,.6-.5h.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M171.4,274.9l.2.3c-.1.2-.5.3-.8.3h-.3l-.2-.3c.1-.2.5-.3.8-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M255.3,224.1c.1.2-.1.5-.6.5H254l-.2-.2c-.1-.2.1-.5.6-.5h.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M167.1,274.3c.2.1.2.2.2.5s-.5.3-.9.3h-.3c-.2-.1-.2-.2-.2-.3s.5-.3.9-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M254.1,221.7c.1.2-.1.5-.5.6h-.7l-.2-.2c-.1-.2.1-.5.5-.6h.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M162.9,273.7c.2.1.2.2.2.5s-.6.3-.9.2h-.3c-.2-.1-.2-.2-.2-.5s.6-.3.9-.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M252.8,219.2c.1.2-.1.5-.5.6a1.1,1.1,0,0,1-.8-.1h-.1c-.1-.2.1-.5.5-.6a1.1,1.1,0,0,1,.8.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M158.8,272.9c.2.1.2.2.1.5s-.6.3-.9.2h-.2c-.2-.1-.2-.2-.1-.5s.6-.3.9-.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M251.1,216.8a.4.4,0,0,1-.3.6,1.1,1.1,0,0,1-.8-.1h-.1a.4.4,0,0,1,.3-.6,1.1,1.1,0,0,1,.8.1A.1.1,0,0,0,251.1,216.8Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M154.6,271.9c.2.1.2.3.1.5s-.6.3-.9.2h-.2c-.2-.1-.2-.3-.1-.5s.6-.3.9-.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M249.3,214.5a.4.4,0,0,1-.3.6,1.1,1.1,0,0,1-.8-.1h-.1c-.2-.2,0-.5.3-.6a1,1,0,0,1,.8.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M150.7,270.8c.2.1.2.3.1.5a1.1,1.1,0,0,1-1,.2h-.2c-.2-.1-.2-.3-.1-.5a1.1,1.1,0,0,1,1-.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M247.2,212.2c.2.2.1.5-.2.6a1,1,0,0,1-.9-.1H246c-.2-.2-.1-.5.2-.6a1,1,0,0,1,.9.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M146.8,269.6c.2.1.2.3.1.5a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.2-.3-.1-.6a1.1,1.1,0,0,1,1-.1C146.7,269.6,146.8,269.6,146.8,269.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M244.9,210.1c.2.2.1.5-.2.6a.9.9,0,0,1-.9-.1h-.1c-.2-.2-.1-.5.2-.6a1.3,1.3,0,0,1,1,.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M143.2,268.2c.2.1.3.3.1.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.6S142.7,268.1,143.2,268.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M242.3,208c.2.2.2.5-.1.6h-1c-.2-.2-.2-.5.1-.6A.8.8,0,0,1,242.3,208Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M139.6,266.7c.2.1.3.3.1.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.2-.3-.1-.6S139.1,266.6,139.6,266.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M239.6,206c.2.2.2.5-.1.6h-1c-.2-.2-.2-.5.1-.6A.9.9,0,0,1,239.6,206Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M136.2,265.1c.2.1.3.5,0,.6a.9.9,0,0,1-1,0c-.2-.1-.3-.5,0-.6A1.7,1.7,0,0,1,136.2,265.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M236.6,204.1c.2.2.2.5,0,.6a1.7,1.7,0,0,1-1,0c-.2-.2-.2-.5,0-.6A.9.9,0,0,1,236.6,204.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M132.9,263.4c.2.1.3.5,0,.6s-.8.1-1,0-.3-.5,0-.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M233.5,202.2a.3.3,0,0,1,0,.6,1.2,1.2,0,0,1-1,0,.4.4,0,0,1,0-.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M130,261.7a.4.4,0,0,1,0,.6h-1c-.2-.2-.2-.5.1-.6S129.6,261.4,130,261.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M230.1,200.6q.3.2,0,.6a.9.9,0,0,1-1,0c-.2-.1-.3-.5-.1-.6A1.4,1.4,0,0,1,230.1,200.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M127.1,259.7c.2.2.2.5-.1.6h-.9c-.2-.2-.2-.5.1-.6S126.7,259.5,127.1,259.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M226.7,199q.3.1,0,.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.2-.3-.1-.6A1.7,1.7,0,0,1,226.7,199Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M124.5,257.8c.2.2.1.5-.2.6a1.4,1.4,0,0,1-.9,0h-.1c-.2-.2-.1-.5.2-.6s.6-.3,1,0Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M223.1,197.6c.2.1.2.3.1.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.6a1.1,1.1,0,0,1,1-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M122,255.6c.2.2.1.5-.2.6a.9.9,0,0,1-.9-.1h-.1c-.2-.2-.1-.5.2-.6A1.6,1.6,0,0,1,122,255.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M219.4,196.3c.2.1.2.3.1.5a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.5a1.1,1.1,0,0,1,1-.1C219.2,196.3,219.4,196.3,219.4,196.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M119.9,253.5c.2.2,0,.5-.3.6s-.7.1-.8-.1h-.1c-.2-.2,0-.5.3-.6a.9.9,0,0,1,.9.1C119.7,253.4,119.9,253.4,119.9,253.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M215.5,195.1c.2.1.2.3.1.5s-.6.3-.9.2h-.2c-.2-.1-.3-.3-.1-.5a1,1,0,0,1,.9-.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M117.9,251.2a.4.4,0,0,1-.3.6,1.1,1.1,0,0,1-.8-.1h-.1a.4.4,0,0,1,.3-.6,1.1,1.1,0,0,1,.8.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M211.4,194.1c.2.1.2.3.1.5s-.6.3-.9.2h-.2c-.2-.1-.3-.3-.1-.5s.6-.3.9-.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M116.2,248.9c.1.2,0,.5-.5.6a1.1,1.1,0,0,1-.8-.1h-.1c-.1-.2,0-.5.5-.6a1.1,1.1,0,0,1,.8.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M207.4,193.2c.2.1.2.2.2.5s-.6.3-.9.2h-.3c-.2-.1-.2-.2-.1-.5s.6-.3.9-.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M114.7,246.5c.1.2-.1.5-.5.6h-.9c-.1-.2.1-.5.5-.6h.9Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M203.2,192.5c.2.1.2.2.2.5s-.5.3-.9.3h-.3c-.2-.1-.2-.2-.2-.5s.6-.3.9-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M113.4,244.1c.1.2-.1.5-.6.6h-.7l-.2-.2c-.1-.2.1-.5.6-.6h.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M198.9,191.8l.2.3c-.1.2-.5.3-.8.3H198l-.2-.3c.1-.2.5-.3.9-.3S198.8,191.8,198.9,191.8Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M112.4,241.7c.1.2-.2.5-.6.5h-.7l-.2-.2c-.1-.2.2-.5.6-.5h.7C112.4,241.5,112.4,241.6,112.4,241.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M194.7,191.3l.2.3c-.1.2-.5.3-.8.3h-.3l-.2-.3c.1-.2.5-.3.8-.3S194.6,191.3,194.7,191.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M111.7,239.2a.6.6,0,0,1-.6.5h-.7l-.2-.2c-.1-.2.2-.5.6-.5h.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M190.3,191.1l.2.3c0,.2-.3.3-.8.3h-.5l-.2-.3c0-.2.3-.5.8-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M111,236.4l.2.2c0,.2-.2.5-.7.5h-.6l-.2-.2c0-.2.2-.5.7-.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M186,190.9l.2.3c0,.2-.3.5-.8.5h-.5l-.2-.3a.7.7,0,0,1,.7-.5C185.6,190.7,185.7,190.9,186,190.9Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M110.8,233.9l.2.3a.7.7,0,0,1-.7.5h-.6l-.2-.3a.7.7,0,0,1,.7-.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M181.5,190.9l.2.3a.7.7,0,0,1-.7.5h-.6l-.2-.3a.7.7,0,0,1,.7-.5C181.1,190.7,181.4,190.9,181.5,190.9Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M110.9,231.4l.2.3c0,.2-.3.5-.8.5h-.5l-.2-.3c0-.2.3-.5.8-.3S110.8,231.3,110.9,231.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M177.1,191.1c.1.1.2.1.2.2s-.2.5-.7.5H176l-.2-.2c0-.2.2-.5.7-.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M111.1,228.8l.2.3c0,.2-.3.5-.8.3H110l-.2-.3c0-.2.3-.5.8-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M173,191.6a.6.6,0,0,1-.6.5h-.7l-.2-.2a.6.6,0,0,1,.6-.5h.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M111.7,226.3l.2.3c0,.2-.5.3-.8.3h-.3l-.2-.3c0-.2.5-.3.8-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M168.7,192c.1.2-.2.5-.6.5h-.7l-.2-.2c-.1-.2.1-.5.6-.5h.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M112.5,223.8l.2.3c-.1.2-.5.3-.9.3h-.3c-.2-.1-.2-.2-.2-.3s.5-.3.9-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M164.4,192.6c.1.2-.1.5-.5.6h-.7l-.2-.2c-.1-.2.1-.5.5-.6h.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M113.7,221.4c.2.1.2.2.2.5s-.6.3-.9.3h-.3c-.2-.1-.2-.2-.2-.5s.6-.3.9-.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M160.3,193.3c.1.2-.1.5-.5.6h-.9c-.1-.2.1-.5.5-.6h.8C160.1,193.2,160.1,193.3,160.3,193.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M114.9,219c.2.1.2.2.1.5s-.6.3-.9.2h-.2c-.2-.1-.2-.2-.1-.5s.6-.3.9-.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M156.1,194.2c.1.2,0,.5-.5.6a1.1,1.1,0,0,1-.8-.1h-.1a.4.4,0,0,1,.3-.6,1.1,1.1,0,0,1,.8.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M116.5,216.6c.2.1.3.3.1.5s-.6.3-.9.2h-.2c-.2-.1-.3-.3-.1-.5s.6-.3.9-.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M118.4,214.3c.2.1.2.3.1.5a1,1,0,0,1-.9.2h-.2c-.2-.1-.2-.3-.1-.5a1,1,0,0,1,.9-.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M120.6,212.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.5a1.1,1.1,0,0,1,1-.1h.1C120.7,212.2,120.7,212.4,120.6,212.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M122.8,210.5a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.6a1.1,1.1,0,0,1,1-.1h.1C123,210,123,210.3,122.8,210.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M125.3,208.4a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.6a1.1,1.1,0,0,1,1-.1h.1C125.5,208,125.5,208.2,125.3,208.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M127,206.5c-.3-.2-.3-.5-.1-.6a.9.9,0,0,1,1,0c.2.1.3.5,0,.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M129.8,204.6a.3.3,0,0,1,0-.6.9.9,0,0,1,1,0,.4.4,0,0,1,0,.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M132.9,202.8a.4.4,0,0,1,0-.6h1a.4.4,0,0,1,0,.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M136.2,201.1c-.2-.2-.2-.5.1-.6h1a.3.3,0,0,1-.1.6A.9.9,0,0,1,136.2,201.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M139.6,199.5c-.2-.2-.2-.5.1-.6h1a.4.4,0,0,1-.1.6A1.2,1.2,0,0,1,139.6,199.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M143.2,198.1c-.2-.2-.1-.5.2-.6a.9.9,0,0,1,.9.1h.1c.2.2.1.5-.2.6A2,2,0,0,1,143.2,198.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M146.9,196.7c-.2-.2-.1-.5.2-.6a.9.9,0,0,1,.9.1.1.1,0,0,1,.1.1c.2.2.1.5-.2.6a.9.9,0,0,1-.9-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M150.7,195.6c-.2-.2,0-.5.3-.6a1,1,0,0,1,.8.1h.1a.4.4,0,0,1-.3.6,1,1,0,0,1-.8-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M250.7,249.5c-.2-.1-.2-.3-.1-.5s.6-.3.9-.2h.2c.2.1.2.3.1.5s-.6.3-.9.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M249,251.8c-.2-.1-.2-.3-.1-.5a1,1,0,0,1,.9-.2h.2c.2.1.2.3.1.5s-.6.3-.9.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M246.9,253.5a1.1,1.1,0,0,1,1-.1h.1c.2.1.3.3.1.5a1.1,1.1,0,0,1-1,.1H247C246.8,254,246.8,253.8,246.9,253.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M244.7,255.7a1.1,1.1,0,0,1,1-.1h.1c.2.1.2.3.1.6a1.1,1.1,0,0,1-1,.1h-.1A.5.5,0,0,1,244.7,255.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M242.3,257.8a1.1,1.1,0,0,1,1-.1h.1c.2.1.3.3.1.6a1.1,1.1,0,0,1-1,.1h-.1C242.2,258.2,242.1,258,242.3,257.8Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M240.7,259.7c.3.2.3.5.1.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3,0-.6A1.1,1.1,0,0,1,240.7,259.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M237.9,261.7c.3.2.3.5,0,.6a.9.9,0,0,1-1,0,.4.4,0,0,1,0-.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M235.7,263.2a.4.4,0,0,1,0,.6h-1c-.3-.2-.3-.5,0-.6S235.3,262.9,235.7,263.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-5"
            d="M222,269.5c.2.2.1.5-.2.6a1,1,0,0,1-.9-.1h-.1c-.2-.2-.1-.5.2-.6A1,1,0,0,1,222,269.5Zm0,0Zm22.9-59.4c.2.2.1.5-.2.6a.9.9,0,0,1-.9-.1h-.1c-.2-.2-.1-.5.2-.6A1.3,1.3,0,0,1,244.9,210.1Zm0,0ZM124.5,257.8c.2.2.1.5-.2.6a1.4,1.4,0,0,1-.9,0h-.1c-.2-.2-.1-.5.2-.6S124.1,257.5,124.5,257.8Zm0,0Zm107.9,7.1c.2.2.2.5-.1.6a1.7,1.7,0,0,1-1,0c-.2-.2-.2-.5.1-.6A.9.9,0,0,1,232.4,264.9Zm-3.3,1.6c.2.2.2.5-.1.6h-1c-.2-.2-.2-.5.1-.6A1.2,1.2,0,0,1,229.1,266.5Zm-3.4,1.5c.2.2.1.5-.2.6h-1c-.2-.2-.1-.5.2-.6A1.7,1.7,0,0,1,225.7,268Zm-7.5,2.7c.2.2.1.5-.3.6a1.1,1.1,0,0,1-.8-.1H217c-.2-.2,0-.5.3-.6a1,1,0,0,1,.8.1Zm-3.9,1.2a.4.4,0,0,1-.3.6,1.1,1.1,0,0,1-.8-.1h-.1a.4.4,0,0,1,.3-.6,1.1,1.1,0,0,1,.8.1Zm-4,1c.1.2,0,.5-.5.6a1.1,1.1,0,0,1-.8-.1h-.1c-.1-.2,0-.5.5-.6h.9ZM253.4,247c-.1.2-.6.3-.9.2h-.2c-.2-.1-.2-.2-.2-.5s.6-.3.9-.2h.3C253.4,246.6,253.6,246.8,253.4,247Zm-47.2,26.7c.1.2-.1.5-.5.6H205l-.2-.2c-.1-.2.1-.5.5-.6h.7C206,273.6,206.2,273.6,206.2,273.7Zm48.5-29.2c-.1.2-.5.3-.9.3h-.3c-.2-.1-.2-.2-.2-.5s.5-.3.9-.3h.3C254.6,244.2,254.7,244.3,254.7,244.5ZM202,274.4c.1.2-.1.5-.6.5h-.7l-.2-.2c-.1-.2.1-.5.6-.6h.7Zm53.4-32.8.2.3c-.1.2-.5.3-.9.3h-.3l-.2-.3c.1-.2.5-.3.9-.3ZM197.7,275c.1.2-.2.5-.6.5h-.7l-.2-.2c-.1-.2.2-.5.6-.5h.7C197.7,274.9,197.7,274.9,197.7,275Zm58.5-35.9.2.3c0,.2-.5.3-.8.3h-.5l-.2-.3c.1-.2.5-.3.8-.3S256.1,239.1,256.2,239.1Zm-62.8,36.3a.6.6,0,0,1-.6.5h-.6l-.2-.2c-.1-.2.2-.5.6-.5h.6A.2.2,0,0,1,193.4,275.4Zm63.3-38.9c.1.1.2.2.2.3s-.3.5-.8.3h-.5c-.1-.1-.2-.2-.2-.3s.3-.5.8-.3Zm-67.9,38.9c.1.1.2.1.2.2s-.2.5-.7.5h-.6l-.2-.2c0-.2.2-.5.7-.5ZM256.9,234c.1.1.2.2.2.3a.7.7,0,0,1-.7.5h-.5l-.2-.3a.7.7,0,0,1,.7-.5Zm-72.4,41.4.2.3a.7.7,0,0,1-.7.5h-.6l-.2-.3a.7.7,0,0,1,.7-.5Zm72.3-43.9.2.2a.7.7,0,0,1-.7.5h-.6l-.2-.2a.7.7,0,0,1,.7-.5Zm-76.7,43.9.2.3c0,.2-.3.5-.8.3H179l-.2-.3c0-.2.3-.5.8-.3Zm76.6-46.2c0,.2-.2.5-.7.5h-.6l-.2-.2c0-.2.2-.5.7-.5h.6Zm-80.9,46c.1.1.2.2.2.3s-.5.3-.8.3h-.5c-.1-.1-.2-.2-.2-.3s.5-.5.8-.3Zm80.3-48.5c.1.2-.2.5-.6.5h-.7l-.2-.2a.6.6,0,0,1,.6-.5h.6Zm-84.7,48.2.2.3c-.1.2-.5.3-.8.3h-.3l-.2-.3c.1-.2.5-.3.8-.3Zm83.9-50.8c.1.2-.1.5-.6.5H254l-.2-.2c-.1-.2.1-.5.6-.5h.7Zm-88.2,50.2c.2.1.2.2.2.5s-.5.3-.9.3h-.3c-.2-.1-.2-.2-.2-.3s.5-.3.9-.3Zm87-52.6c.1.2-.1.5-.5.6h-.7l-.2-.2c-.1-.2.1-.5.5-.6h.7Zm-91.2,52c.2.1.2.2.2.5s-.6.3-.9.2h-.3c-.2-.1-.2-.2-.2-.5s.6-.3.9-.2Zm89.9-54.5c.1.2-.1.5-.5.6a1.1,1.1,0,0,1-.8-.1h-.1c-.1-.2.1-.5.5-.6a1.1,1.1,0,0,1,.8.1Zm-94,53.7c.2.1.2.2.1.5s-.6.3-.9.2h-.2c-.2-.1-.2-.2-.1-.5s.6-.3.9-.2Zm92.3-56.1a.4.4,0,0,1-.3.6,1.1,1.1,0,0,1-.8-.1h-.1a.4.4,0,0,1,.3-.6,1.1,1.1,0,0,1,.8.1A.1.1,0,0,0,251.1,216.8Zm-96.5,55.1c.2.1.2.3.1.5s-.6.3-.9.2h-.2c-.2-.1-.2-.3-.1-.5s.6-.3.9-.2Zm94.7-57.4a.4.4,0,0,1-.3.6,1.1,1.1,0,0,1-.8-.1h-.1c-.2-.2,0-.5.3-.6a1,1,0,0,1,.8.1Zm-98.6,56.3c.2.1.2.3.1.5a1.1,1.1,0,0,1-1,.2h-.2c-.2-.1-.2-.3-.1-.5a1.1,1.1,0,0,1,1-.2Zm96.5-58.6c.2.2.1.5-.2.6a1,1,0,0,1-.9-.1H246c-.2-.2-.1-.5.2-.6a1,1,0,0,1,.9.1ZM146.8,269.6c.2.1.2.3.1.5a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.2-.3-.1-.6a1.1,1.1,0,0,1,1-.1C146.7,269.6,146.8,269.6,146.8,269.6Zm-3.6-1.4c.2.1.3.3.1.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.6S142.7,268.1,143.2,268.2ZM242.3,208c.2.2.2.5-.1.6h-1c-.2-.2-.2-.5.1-.6A.8.8,0,0,1,242.3,208ZM139.6,266.7c.2.1.3.3.1.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.2-.3-.1-.6S139.1,266.6,139.6,266.7Zm100-60.7c.2.2.2.5-.1.6h-1c-.2-.2-.2-.5.1-.6A.9.9,0,0,1,239.6,206ZM136.2,265.1c.2.1.3.5,0,.6a.9.9,0,0,1-1,0c-.2-.1-.3-.5,0-.6A1.7,1.7,0,0,1,136.2,265.1Zm100.4-61c.2.2.2.5,0,.6a1.7,1.7,0,0,1-1,0c-.2-.2-.2-.5,0-.6A.9.9,0,0,1,236.6,204.1ZM132.9,263.4c.2.1.3.5,0,.6s-.8.1-1,0-.3-.5,0-.6Zm100.6-61.2a.3.3,0,0,1,0,.6,1.2,1.2,0,0,1-1,0,.4.4,0,0,1,0-.6ZM130,261.7a.4.4,0,0,1,0,.6h-1c-.2-.2-.2-.5.1-.6S129.6,261.4,130,261.7Zm100.1-61.1q.3.2,0,.6a.9.9,0,0,1-1,0c-.2-.1-.3-.5-.1-.6A1.4,1.4,0,0,1,230.1,200.6Zm-103,59.1c.2.2.2.5-.1.6h-.9c-.2-.2-.2-.5.1-.6S126.7,259.5,127.1,259.7ZM226.7,199q.3.1,0,.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.2-.3-.1-.6A1.7,1.7,0,0,1,226.7,199Zm-3.6-1.4c.2.1.2.3.1.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.6a1.1,1.1,0,0,1,1-.1ZM122,255.6c.2.2.1.5-.2.6a.9.9,0,0,1-.9-.1h-.1c-.2-.2-.1-.5.2-.6A1.6,1.6,0,0,1,122,255.6Zm97.4-59.3c.2.1.2.3.1.5a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.5a1.1,1.1,0,0,1,1-.1C219.2,196.3,219.4,196.3,219.4,196.3Zm-99.5,57.2c.2.2,0,.5-.3.6s-.7.1-.8-.1h-.1c-.2-.2,0-.5.3-.6a.9.9,0,0,1,.9.1C119.7,253.4,119.9,253.4,119.9,253.5Zm95.6-58.4c.2.1.2.3.1.5s-.6.3-.9.2h-.2c-.2-.1-.3-.3-.1-.5a1,1,0,0,1,.9-.2Zm-97.6,56.1a.4.4,0,0,1-.3.6,1.1,1.1,0,0,1-.8-.1h-.1a.4.4,0,0,1,.3-.6,1.1,1.1,0,0,1,.8.1Zm93.5-57.1c.2.1.2.3.1.5s-.6.3-.9.2h-.2c-.2-.1-.3-.3-.1-.5s.6-.3.9-.2Zm-95.2,54.8c.1.2,0,.5-.5.6a1.1,1.1,0,0,1-.8-.1h-.1c-.1-.2,0-.5.5-.6a1.1,1.1,0,0,1,.8.1Zm91.2-55.7c.2.1.2.2.2.5s-.6.3-.9.2h-.3c-.2-.1-.2-.2-.1-.5s.6-.3.9-.2Zm-92.7,53.3c.1.2-.1.5-.5.6h-.9c-.1-.2.1-.5.5-.6h.9Zm88.5-54c.2.1.2.2.2.5s-.5.3-.9.3h-.3c-.2-.1-.2-.2-.2-.5s.6-.3.9-.3Zm-89.8,51.6c.1.2-.1.5-.6.6h-.7l-.2-.2c-.1-.2.1-.5.6-.6h.7Zm85.5-52.3.2.3c-.1.2-.5.3-.8.3H198l-.2-.3c.1-.2.5-.3.9-.3S198.8,191.8,198.9,191.8Zm-86.5,49.9c.1.2-.2.5-.6.5h-.7l-.2-.2c-.1-.2.2-.5.6-.5h.7C112.4,241.5,112.4,241.6,112.4,241.7Zm82.3-50.4.2.3c-.1.2-.5.3-.8.3h-.3l-.2-.3c.1-.2.5-.3.8-.3S194.6,191.3,194.7,191.3Zm-83,47.9a.6.6,0,0,1-.6.5h-.7l-.2-.2c-.1-.2.2-.5.6-.5h.6Zm78.6-48.1.2.3c0,.2-.3.3-.8.3h-.5l-.2-.3c0-.2.3-.5.8-.3ZM111,236.4l.2.2c0,.2-.2.5-.7.5h-.6l-.2-.2c0-.2.2-.5.7-.5Zm75-45.5.2.3c0,.2-.3.5-.8.5h-.5l-.2-.3a.7.7,0,0,1,.7-.5C185.6,190.7,185.7,190.9,186,190.9Zm-75.2,43,.2.3a.7.7,0,0,1-.7.5h-.6l-.2-.3a.7.7,0,0,1,.7-.5Zm70.7-43,.2.3a.7.7,0,0,1-.7.5h-.6l-.2-.3a.7.7,0,0,1,.7-.5C181.1,190.7,181.4,190.9,181.5,190.9Zm-70.6,40.5.2.3c0,.2-.3.5-.8.5h-.5l-.2-.3c0-.2.3-.5.8-.3S110.8,231.3,110.9,231.4Zm66.2-40.3c.1.1.2.1.2.2s-.2.5-.7.5H176l-.2-.2c0-.2.2-.5.7-.5Zm-66,37.7.2.3c0,.2-.3.5-.8.3H110l-.2-.3c0-.2.3-.5.8-.3ZM173,191.6a.6.6,0,0,1-.6.5h-.7l-.2-.2a.6.6,0,0,1,.6-.5h.7Zm-61.3,34.7.2.3c0,.2-.5.3-.8.3h-.3l-.2-.3c0-.2.5-.3.8-.3Zm57-34.3c.1.2-.2.5-.6.5h-.7l-.2-.2c-.1-.2.1-.5.6-.5h.7Zm-56.2,31.8.2.3c-.1.2-.5.3-.9.3h-.3c-.2-.1-.2-.2-.2-.3s.5-.3.9-.3Zm51.9-31.2c.1.2-.1.5-.5.6h-.7l-.2-.2c-.1-.2.1-.5.5-.6h.7Zm-50.7,28.8c.2.1.2.2.2.5s-.6.3-.9.3h-.3c-.2-.1-.2-.2-.2-.5s.6-.3.9-.3Zm46.6-28.1c.1.2-.1.5-.5.6h-.9c-.1-.2.1-.5.5-.6h.8C160.1,193.2,160.1,193.3,160.3,193.3ZM114.9,219c.2.1.2.2.1.5s-.6.3-.9.2h-.2c-.2-.1-.2-.2-.1-.5s.6-.3.9-.2Zm41.2-24.8c.1.2,0,.5-.5.6a1.1,1.1,0,0,1-.8-.1h-.1a.4.4,0,0,1,.3-.6,1.1,1.1,0,0,1,.8.1Zm-39.6,22.4c.2.1.3.3.1.5s-.6.3-.9.2h-.2c-.2-.1-.3-.3-.1-.5s.6-.3.9-.2Zm1.9-2.3c.2.1.2.3.1.5a1,1,0,0,1-.9.2h-.2c-.2-.1-.2-.3-.1-.5a1,1,0,0,1,.9-.2Zm2.2-1.7a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.5a1.1,1.1,0,0,1,1-.1h.1C120.7,212.2,120.7,212.4,120.6,212.6Zm2.2-2.1a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.6a1.1,1.1,0,0,1,1-.1h.1C123,210,123,210.3,122.8,210.5Zm2.5-2.1a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3-.1-.6a1.1,1.1,0,0,1,1-.1h.1C125.5,208,125.5,208.2,125.3,208.4Zm1.7-1.9c-.3-.2-.3-.5-.1-.6a.9.9,0,0,1,1,0c.2.1.3.5,0,.6Zm2.8-1.9a.3.3,0,0,1,0-.6.9.9,0,0,1,1,0,.4.4,0,0,1,0,.6Zm3.1-1.8a.4.4,0,0,1,0-.6h1a.4.4,0,0,1,0,.6Zm3.3-1.7c-.2-.2-.2-.5.1-.6h1a.3.3,0,0,1-.1.6A.9.9,0,0,1,136.2,201.1Zm3.4-1.6c-.2-.2-.2-.5.1-.6h1a.4.4,0,0,1-.1.6A1.2,1.2,0,0,1,139.6,199.5Zm3.6-1.4c-.2-.2-.1-.5.2-.6a.9.9,0,0,1,.9.1h.1c.2.2.1.5-.2.6A2,2,0,0,1,143.2,198.1Zm3.7-1.4c-.2-.2-.1-.5.2-.6a.9.9,0,0,1,.9.1.1.1,0,0,1,.1.1c.2.2.1.5-.2.6a.9.9,0,0,1-.9-.1Zm3.8-1.1c-.2-.2,0-.5.3-.6a1,1,0,0,1,.8.1h.1a.4.4,0,0,1-.3.6,1,1,0,0,1-.8-.1Zm100,53.9c-.2-.1-.2-.3-.1-.5s.6-.3.9-.2h.2c.2.1.2.3.1.5s-.6.3-.9.2Zm-1.7,2.3c-.2-.1-.2-.3-.1-.5a1,1,0,0,1,.9-.2h.2c.2.1.2.3.1.5s-.6.3-.9.2Zm-2.1,1.7a1.1,1.1,0,0,1,1-.1h.1c.2.1.3.3.1.5a1.1,1.1,0,0,1-1,.1H247C246.8,254,246.8,253.8,246.9,253.5Zm-2.2,2.2a1.1,1.1,0,0,1,1-.1h.1c.2.1.2.3.1.6a1.1,1.1,0,0,1-1,.1h-.1A.5.5,0,0,1,244.7,255.7Zm-2.4,2.1a1.1,1.1,0,0,1,1-.1h.1c.2.1.3.3.1.6a1.1,1.1,0,0,1-1,.1h-.1C242.2,258.2,242.1,258,242.3,257.8Zm-1.6,1.9c.3.2.3.5.1.6a1.1,1.1,0,0,1-1,.1h-.1c-.2-.1-.3-.3,0-.6A1.1,1.1,0,0,1,240.7,259.7Zm-2.8,2c.3.2.3.5,0,.6a.9.9,0,0,1-1,0,.4.4,0,0,1,0-.6Zm-2.2,1.5a.4.4,0,0,1,0,.6h-1c-.3-.2-.3-.5,0-.6S235.3,262.9,235.7,263.2Z"
            transform="translate(-0.5 -2.3)"
          />
        </g>
      </g>
      <g id="Shadows">
        <path
          class="cls-6"
          d="M135.1,120.1l51.3,29.8-1.8,1.2L133,121.2Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M200.9,140.1a3,3,0,0,1-1.2,1.5l-51.3-29.5,2.1-.9Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M196.7,143.6l-2.1,1.2-51.3-29.5,1.8-1.2Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M191.4,146.9l-1.8.9-51.3-29.5,1.8-1.2Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M154,168.4c-.3,0-.3.3-.6.3l-50.1-28.9a6.6,6.6,0,0,1,.9-1.5l35.1,20.3.6-.3L241.6,217l-.3.3-1.5.9Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M133,162.2l1.8-1.2,102,59-1.8,1.2Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M127.7,165.2l1.8-.9L231.2,223l-.3.3-1.2.9Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M122.7,168.1l1.8-.9,102,58.7-1.8,1.2Z"
          transform="translate(-0.5 -2.3)"
        />
        <path class="cls-6" d="M117.4,171.1l1.8-.9,102,59-1.8.9Z" transform="translate(-0.5 -2.3)" />
        <path
          class="cls-6"
          d="M112.4,174.3l1.8-1.2,102,59-1.8.9Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M107.1,177.3l1.8-1.2,102,59-.3.3-1.5.9Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M102.1,180.2l1.8-1.2,102,59-1.8,1.2Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M96.8,183.2l1.8-.9L200.3,241l-.3.3-1.2.9Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M91.5,186.1l2.1-.9,101.7,58.7v.3l-1.8.9Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M87.9,190.2a6.6,6.6,0,0,1,.9-1.5l101.1,58.4-.3.3a4.3,4.3,0,0,1-1.8.6Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M87.1,193.5l95.8,55.4h-3.8L87.4,196.1A17,17,0,0,0,87.1,193.5Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M180.2,153.4l-.6.3-51.3-29.8,1.8-1.2,37.4,21.8h1.2l94,54.2c0,.6.3,1.5,0,2.1Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M174.9,156.6l-.6.3L123,127.1l1.8-1.2,35.4,20.3a1,1,0,0,0,.6-.3l100.8,58.7a5.3,5.3,0,0,1-1.2,1.5Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M255.7,209.1l-85.8-49.5-.6.3-51.6-29.8,2.1-.9,35.1,20.3.6-.3,102,58.7Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M164.6,162.5l-.6.3-51.3-29.5,1.8-1.2,35.1,20.3.6-.3,102,59-1.8.9Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          class="cls-6"
          d="M159.6,165.5l-.6.6-51.3-29.8,1.8-1.2,35.1,20.3.6-.3,102,59-1.8.9Z"
          transform="translate(-0.5 -2.3)"
        />
      </g>
      <g id="LaptopGroup">
        <g id="Laptop">
          <path
            class="cls-7"
            d="M255.6,188.2v-2a5.3,5.3,0,0,1-1.4,1.1l-66.1,40.3c-2.9,1.8-7.3,2-9.8.6L74.7,171.5a1.8,1.8,0,0,1-.7-.5v2.1a2.3,2.3,0,0,0,1.4,1.8L179,231.7c2.3,1.2,6,.9,8.6-.6l66-40.2A5.1,5.1,0,0,0,255.6,188.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M73.8,168.7a2.6,2.6,0,0,0,1.3,1.7l42.3,23.2a2.1,2.1,0,0,1,1.9,0h0l16.9,9.3a1.1,1.1,0,0,1,.6,1,.4.4,0,0,1-.1.3l41.9,22.9c2.3,1.2,6,.9,8.6-.6l26.2-15.9L102.2,149.9,75.5,166.1a.2.2,0,0,0-.2.2l-.7.4A2.9,2.9,0,0,0,73.8,168.7Zm39,16.4,7.6-4.6h.4l.2-.2,13.9-8.5a4.2,4.2,0,0,1,3.1-.3l.5.2,34.7,18.9.4.3h.1l.2.2h0a1.4,1.4,0,0,1,.1,1.4l-.2.2a1.3,1.3,0,0,1-.7.5l-13.8,8.5h-.2v.2h-.2l-7.6,4.6a4.6,4.6,0,0,1-2,.5,3.3,3.3,0,0,1-1.7-.4l-17-9.3c-.2-.1-.3-.2-.3-.4h-.4l-17-9.3a2,2,0,0,1-.8-.8h0C111.7,186.3,112,185.6,112.8,185.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M173.3,179.2h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M166.3,175.4Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M159.3,171.5h0Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M194.5,190.6h0C194.4,190.7,194.4,190.6,194.5,190.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M201.2,163.6Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M187.3,186.9h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M204.6,188.5h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M177.2,158.4Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M174.2,156.1Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M156.1,146.9Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M167.2,152.3Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M160.1,148.4h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M188.2,163.8Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M152.3,167.9h0v-.2l-.8.2h-.2A1.2,1.2,0,0,1,152.3,167.9Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M142.8,163.1Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M153.2,144.7h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M141.5,153.9h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M186.6,187h0Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M108.8,151.9a1,1,0,0,1,.5-.8l4.8-3a2.2,2.2,0,0,1,1.4-.3,1,1,0,0,1,.5-.8l4.8-3a1.6,1.6,0,0,1,1.5-.2,1.2,1.2,0,0,1,.5-.9l4.8-3a2.2,2.2,0,0,1,1.4-.3,1,1,0,0,1,.5-.8l4.8-3a2.2,2.2,0,0,1,1.4-.3,1.4,1.4,0,0,1,.5-1l4.8-3a2.2,2.2,0,0,1,1.4-.3,1,1,0,0,1,.5-.8l2.4-1.5a1.8,1.8,0,0,1,1.9-.1l8.3,4.6c.3.1.4.4.5.7v.2a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7h0a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7v.3a1.8,1.8,0,0,1,1.6,0l5.1,2.8c.3.1.4.4.5.7h0a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7v.2a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7h0a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7v.2a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7h0a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7v.2a1.8,1.8,0,0,1,1.6.1l5.1,2.8c.3.1.4.4.5.7v.2a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7h0a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7v.2a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7h0a1.4,1.4,0,0,1,1.4.1l5.1,2.8c.3.1.4.4.5.7a1.4,1.4,0,0,1-.5,1l-2.4,1.5a2,2,0,0,1-1.1.3h-.3a1.4,1.4,0,0,1-.5.9l-4.8,3a2,2,0,0,1-1.1.3h-.3v.2a.9.9,0,0,1-.6.6l-4.8,3a2,2,0,0,1-1.1.3h-.4a1.1,1.1,0,0,1-.6.9l-4.8,3a2,2,0,0,1-1.1.3h-.3a.8.8,0,0,1-.6.8l-4.8,3a2,2,0,0,1-1.1.3h-.3a1,1,0,0,1-.5.8l-4.8,3-.7.3,4.7,2.6,38.9-23.7a3.4,3.4,0,0,0,1.9-2.5,1.6,1.6,0,0,0-.7-1.3l-.7-.3-7.8-4.2-.7.4h-.6l-87.7-47.9a.6.6,0,0,1,0-1l.3-.2-7.1-3.9h0l-.8-.5a10.5,10.5,0,0,0-7.7,1l-38.3,23.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M187.2,155.9Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M180.4,191h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M149.2,143.1h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M210.7,184.5h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M159.1,140.6Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M129.8,163.4Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M219.3,181.3h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M170.3,154.5h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M172.2,171.3Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M150.2,150.9h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M176.6,173.1h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M168.4,161.5Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M198.2,169.9Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M162.6,165.5Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M169.6,169.3Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M155.5,161.6h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M186.2,179Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M192.4,173.9Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M151.1,159.8Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M178.4,166.2Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M164.4,158.7v-.2h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M190.6,180.8h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M165.2,167.5Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M200.2,186.7Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M222.3,175.1Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M208.2,167.4Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M212.2,177.5Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M209.4,175.2h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M202.2,171.5h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M205.2,173.7Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M236.3,182.8Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M180.2,183h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M184.2,162.3Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M206.4,181.6h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M147.5,150Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M145,163.8h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M223.3,183Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M213.3,185.4h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M161.4,157.7Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M202.1,163.6Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M209.1,167.4Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M194.5,159.8h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M216.1,171.2h-1v.2l1-.2Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M229.6,178.9h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M201.4,194.6Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M189.1,195.7Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M237.2,182.7Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M167,144.3h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M128.8,155.5h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M145.4,171.8Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M136.8,167.1Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M160,140.5Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M136.2,143.3h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M146.2,140.7h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M180.5,152.1h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M202,195.5h0Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M131.2,156.2Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M137.1,152.2Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M195.9,199.5h.3v-.2Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M123,159.4h-.1C122.9,159.5,122.9,159.4,123,159.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M115.8,155.6Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M142.2,139.2Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M153,136.7Z" transform="translate(-0.5 -2.3)" />
          <path class="cls-4" d="M173,148.3h0Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-6"
            d="M150.7,123.4l104.2,56.9a1.9,1.9,0,0,0,1.9.2,1.8,1.8,0,0,0,.7-1.7l-1.8-79.5a6.9,6.9,0,0,0-3.3-5.4L148.2,37a3.4,3.4,0,0,0-1.2-.4l-.7.2a1.8,1.8,0,0,0-.7,1.7l1.8,79.5A6.6,6.6,0,0,0,150.7,123.4Zm-1.6-81.9a1.3,1.3,0,0,1,1.2-.1l77.5,42.4,1,.5h0L252.1,97a1.1,1.1,0,0,1,.6,1.1l1.7,72.7h0a1.1,1.1,0,0,1-.6,1.1l-.7.2h-.6L151,116.5h-.2l-.3-.2a1.3,1.3,0,0,1-.4-.9l-1.7-72.7A1.2,1.2,0,0,1,149.1,41.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-7"
            d="M228.5,85.5l-62.4,37.9,87,47.6h.1v-.2l-1.7-72.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            d="M150.5,116.2l.3.2h.2l101.6,55.6h.6l.7-.2a1.3,1.3,0,0,0,.6-1.1h0l-1.7-72.7a1.4,1.4,0,0,0-.6-1.1L228.9,84.4h0l-1-.5L150.4,41.5a1,1,0,0,0-1.2.1,1.3,1.3,0,0,0-.6,1.2l1.7,72.7A.7.7,0,0,0,150.5,116.2Zm-.8-73.8h.1l31.4,17.2,46.2,25.2-62.4,38-13.6-7.5-1.7-72.7C149.6,42.5,149.6,42.5,149.7,42.4ZM253.2,171.1h-.1l-87-47.6,62.4-37.9,23.1,12.6,1.7,72.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-7"
            d="M164.9,122.8l62.4-38L181.1,59.6,149.7,42.4h-.1a.3.3,0,0,0-.1.2l1.7,72.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M172.6,192.3l-34.5-18.9a2.8,2.8,0,0,0-2.5.1L123.1,181,159,200.5l13.6-8.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M156.8,202.2,140,193l-7.4,4.4,15.5,8.5a3.1,3.1,0,0,0,2.5-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M120.7,182.5l-7.3,4.4h.1l16.7,9.1,7.3-4.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            d="M112.2,187.2a2,2,0,0,0,.8.8l17,9.3h.4c0,.2.1.3.3.4l17,9.3a4.7,4.7,0,0,0,1.7.4,4.6,4.6,0,0,0,2-.5l7.6-4.6h.2V202h.2l13.8-8.5.7-.5.2-.2a1.4,1.4,0,0,0-.1-1.4h0l-.2-.2h-.1l-.4-.3-34.7-18.9-.5-.2a4.2,4.2,0,0,0-3.1.3l-13.9,8.5-.2.2h-.4l-7.6,4.6a1.3,1.3,0,0,0-.7,2ZM148.1,206l-15.5-8.5,7.4-4.4,16.8,9.2-6.1,3.7A4.6,4.6,0,0,1,148.1,206Zm-25-24.9,12.5-7.5a2.8,2.8,0,0,1,2.5-.1l34.5,18.9h0L159,200.7Zm-9.6,5.8h0l7.2-4.5,16.8,9.2-7.3,4.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M237.3,189.5l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M224.5,182.9Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M230.3,185.7l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7A.9.9,0,0,0,230.3,185.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M222.4,176.3l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7C223,176.1,222.7,176.2,222.4,176.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M215.4,172.5l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7C216,172.3,215.7,172.4,215.4,172.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M210.2,175.7l.3-.5h0Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M208.3,168.6l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7C208.9,168.4,208.5,168.5,208.3,168.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M201.3,164.8l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M194.3,161l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9L195,161Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M187.3,157.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9L188,157Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M180.3,153.4l-4.7,2.8,4.9,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7A1.1,1.1,0,0,0,180.3,153.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M175.3,156Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M173.3,149.5l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7A.6.6,0,0,0,173.3,149.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M166.2,145.7l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7A.6.6,0,0,0,166.2,145.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M159.2,141.8l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7A.6.6,0,0,0,159.2,141.8Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M147.2,140.7Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M152.2,138l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7A.6.6,0,0,0,152.2,138Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M142,132.4l-4.6,2.9,8,4.4c.1.1.4.1.7-.1l4.6-2.9-8-4.4A.6.6,0,0,0,142,132.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M135.2,136.6l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7C135.8,136.4,135.4,136.5,135.2,136.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M137.6,143.3l4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M148,143.2Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M144.6,147.1l4.8,2.7c.1.1.4.1.7-.1l4.5-2.8-4.7-2.6c-.1-.1-.4-.1-.7.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M151.6,151l4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M169,154.6Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M163.2,151.9l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7A.6.6,0,0,0,163.2,151.9Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M170.3,155.8l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7C170.9,155.6,170.6,155.6,170.3,155.8Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M177.3,159.5l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M184.3,163.5l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7A.6.6,0,0,0,184.3,163.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M191.3,167.2l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M197.2,170h0l.3-.5Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M193.7,174l4.8,2.7c.1.1.4.1.7-.1l4.6-2.9L199,171c-.1-.1-.4-.1-.7.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M200.7,177.8l4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M217.9,181.3l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M220.3,188.1l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7A.9.9,0,0,0,220.3,188.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M230.5,193.6l4.6-2.9-8-4.4c-.1-.1-.4-.1-.7.1l-4.6,2.9,8,4.4A.9.9,0,0,0,230.5,193.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M128.4,140.7l-4.6,2.9,9.9,5.4c.1.1.4.1.7-.1L139,146l-9.9-5.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M228.6,195Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M223.6,197.7l4.6-2.9-9.9-5.4c-.1-.1-.4-.1-.7.1l-4.6,2.9,9.9,5.4A.6.6,0,0,0,223.6,197.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M141.3,152.7l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7A.6.6,0,0,0,141.3,152.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M148.3,156.6l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7A.6.6,0,0,0,148.3,156.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M160.3,157.8l.3-.5-.3.5Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M160,157.6l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M167,161.5l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M174.1,165.2l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M175.6,166.4l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M183.5,175.8l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7C182.9,176,183.2,176,183.5,175.8Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M189.6,174.1,185,177l4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M195.4,176.9Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M197.5,183.5l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7C196.9,183.7,197.2,183.6,197.5,183.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M209.4,184.6h0l.3-.5Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M209.1,184.4l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M211.6,191.2l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7C211,191.4,211.4,191.3,211.6,191.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M121.6,144.9l-4.6,2.9,13.4,7.3c.1.1.4.1.7-.1l4.6-2.9-13.4-7.3A.6.6,0,0,0,121.6,144.9Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M132.5,156.2l4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M150,159.9Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M145,162.6l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7A.6.6,0,0,0,145,162.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M152,166.5l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7A.6.6,0,0,0,152,166.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M163.8,167.4l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M170.8,171.3l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M178.1,175.3Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M177.8,175.1l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M184.8,178.9l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M185.1,179.1Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M187.1,185.7l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7A.9.9,0,0,0,187.1,185.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M199.1,186.8Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M198.8,186.6l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M205.9,190.5l-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7c.1.1.4.1.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M221.8,199.2Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M216.9,201.9l4.6-2.9-13.4-7.4c-.1-.1-.4-.1-.7.1l-4.6,2.9,13.4,7.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M180.4,189.8l4.6-2.9L152.1,169c-.1-.1-.4-.1-.7.1l-4.6,2.9,32.9,17.9C179.8,190,180.1,190,180.4,189.8Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M141.7,163.2Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M136.8,165.9l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7C136.2,166.1,136.5,166.1,136.8,165.9Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M145.2,170.6l4.6-2.9-6.4-3.5c-.1-.1-.4-.1-.7.1l-4.6,2.9,6.4,3.5A.6.6,0,0,0,145.2,170.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M200.6,195.4l-4.8-2.7a.8.8,0,0,0-.7.1l-4.6,2.9,4.8,2.7a.8.8,0,0,0,.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M189,194.5l4.6-2.9-6.4-3.5h0a.7.7,0,0,0-.6.1l-4.7,2.9,6.4,3.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M115.6,154.5l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M122.6,158.3l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1l-4.6,2.9,4.8,2.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M127.6,155.6h0l.3-.5Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M124.3,159.6l4.8,2.7c.1.1.4.1.7-.1l4.6-2.9-4.8-2.7c-.1-.1-.4-.1-.7.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M214.7,203.1l-11.9-6.5a.6.6,0,0,0-.7.1l-4.6,2.9,11.9,6.5a.6.6,0,0,0,.7-.1Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M244.1,185.3l2.2-1.4-4.8-2.7c-.1-.1-.4-.1-.7.1l-2.2,1.4,4.8,2.7C243.5,185.5,243.8,185.5,244.1,185.3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M233.8,177.6l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7A.6.6,0,0,0,233.8,177.6Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M226.8,173.7l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7A.6.6,0,0,0,226.8,173.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M219.8,169.9l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7A.6.6,0,0,0,219.8,169.9Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M217,171.6l.3-.5h0Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M212.8,166l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7A.6.6,0,0,0,212.8,166Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M205.7,162.2l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7A.6.6,0,0,0,205.7,162.2Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M198.7,158.4l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7A.9.9,0,0,0,198.7,158.4Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M191.7,154.5l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7A.9.9,0,0,0,191.7,154.5Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M184.7,150.7l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7A.9.9,0,0,0,184.7,150.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M182.1,151.9Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M177.7,146.8l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7A.9.9,0,0,0,177.7,146.8Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M170.7,143l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7A.9.9,0,0,0,170.7,143Z"
            transform="translate(-0.5 -2.3)"
          />
          <path class="cls-4" d="M167.8,144.7l.3-.5h0Z" transform="translate(-0.5 -2.3)" />
          <path
            class="cls-4"
            d="M163.6,139.1l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M156.6,135.3l-2.2,1.4,4.8,2.7c.1.1.4.1.7-.1l2.2-1.4-4.8-2.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M146.3,129.7l-2.2,1.4,8,4.4c.1.1.4.1.7-.1L155,134l-8-4.4C146.9,129.5,146.6,129.6,146.3,129.7Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            class="cls-4"
            d="M258,99.6c-.1-4.4-1.7-6.1-4.2-7.5L150.2,35.4a2.9,2.9,0,0,0-2.2-.5h-.2l1.1.5L252.5,92.2c3.3,1.9,4.7,4.2,4.8,8.5l1.8,77.4h0a11.1,11.1,0,0,1-.2,1.9c.6-.5.8-1.5.8-3Z"
            transform="translate(-0.5 -2.3)"
          />
          <path
            d="M259.2,99.6c-.1-4.3-1.5-6.7-4.8-8.5L150.8,34.4a3.8,3.8,0,0,0-3.3-.5c-.1,0-.1,0-.1.1l-1.8,1.1h-.2c-1,.6-1.5,2-1.4,4.2l1.8,77.3c0,3.4.8,5.3,2,6.6a12.8,12.8,0,0,0-6.4,1.4l-39.1,23.9h-.1l-27,16.4-.3.2-.5.3h-.2a3.6,3.6,0,0,0-1.5,3.1c0,.2.1.4.1.6v3.8a3.4,3.4,0,0,0,1.9,2.8l103.6,56.7a8.7,8.7,0,0,0,4,.9,11.3,11.3,0,0,0,5.7-1.5l66.1-40.3a.1.1,0,0,0,.1-.1c1.5-1.4,2.2-2.4,2.4-3.5h0v-4.7a3.6,3.6,0,0,0-.2-1,2.1,2.1,0,0,0,1.2-.4h.3l1.4-.9c1.2-.6,1.7-1.9,1.7-4.2ZM179,231.7,75.4,175c-.9-.6-1.4-1.2-1.4-1.8v-2.1l.7.5,103.6,56.7c2.5,1.4,6.9,1.2,9.8-.6l66.1-40.3,1.4-1.1v2a5.7,5.7,0,0,1-2,2.7l-66,40.2C185.1,232.6,181.3,232.9,179,231.7ZM149.6,124.8l.8.5h0l7.1,3.9-.3.2a.6.6,0,0,0,0,1l87.7,47.9h.6l.7-.4,7.8,4.2.7.3a1.9,1.9,0,0,1,.7,1.3,3.2,3.2,0,0,1-1.9,2.5l-38.9,23.7-4.7-2.6c.3-.1.5-.1.7-.3l4.8-3a1,1,0,0,0,.5-.8h.3a2,2,0,0,0,1.1-.3l4.8-3c.1-.1.6-.4.6-.8h.3a2,2,0,0,0,1.1-.3l4.8-3c.1-.1.6-.4.6-.9h.4a2,2,0,0,0,1.1-.3l4.8-3a1.2,1.2,0,0,0,.6-.6v-.2h.3a2,2,0,0,0,1.1-.3l4.8-3a1.1,1.1,0,0,0,.5-.9h.3a2,2,0,0,0,1.1-.3l2.4-1.5a1,1,0,0,0,.5-1,.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1h0a.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1v-.2a.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1h0a.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1v-.2a.8.8,0,0,0-.5-.7l-5.1-2.8a1.8,1.8,0,0,0-1.6-.1v-.2a.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1h0a.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1v-.2a.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1h0a.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1v-.2a.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1h0a.8.8,0,0,0-.5-.7l-5.1-2.8a1.5,1.5,0,0,0-1.6,0v-.3a.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1h0a.8.8,0,0,0-.5-.7l-5.1-2.8a1.4,1.4,0,0,0-1.4-.1v-.2a.8.8,0,0,0-.5-.7l-8.3-4.6a1.8,1.8,0,0,0-1.9.1l-2.4,1.5a1,1,0,0,0-.5.8,1.7,1.7,0,0,0-1.4.3l-4.8,3a1,1,0,0,0-.5,1,1.7,1.7,0,0,0-1.4.3l-4.8,3a1,1,0,0,0-.5.8,1.7,1.7,0,0,0-1.4.3l-4.8,3a1.1,1.1,0,0,0-.5.9,1.9,1.9,0,0,0-1.5.2l-4.8,3a1,1,0,0,0-.5.8,1.7,1.7,0,0,0-1.4.3l-4.8,3a1,1,0,0,0-.5.8l-5.1-2.8L142,126.6A7.7,7.7,0,0,1,149.6,124.8Zm-4-86.2a2,2,0,0,1,.7-1.7l.7-.2a1.9,1.9,0,0,1,1.2.4L252.4,94a6.7,6.7,0,0,1,3.3,5.4l1.8,79.5a2,2,0,0,1-.7,1.7,1.9,1.9,0,0,1-1.9-.2L150.7,123.5a6.7,6.7,0,0,1-3.3-5.4Zm83,156.4Zm-6.8,4.2ZM180.4,191h0Zm-50.6-27.6h0Zm52.3-11.5Zm-60.3.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7Zm37.3-12.2Zm28.1,15.3Zm14,7.7Zm7,3.8Zm14.1,7.7Zm14,7.7ZM148,143.2Zm-.8-2.5Zm53.4,52.8-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9Zm-58.9-30.3Zm33.6-7.2Zm48,27Zm-10,2.4h0ZM180.2,183h0ZM145,163.8h0Zm25.3-9.3h0Zm42.3,29.8-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9A.9.9,0,0,1,212.6,184.3Zm-8.8,3.1-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9C204.2,187.4,203.9,187.5,203.8,187.4ZM156.9,148l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9A.6.6,0,0,1,156.9,148Zm12.1,6.6Zm30,16.5,4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9C198.6,171,198.9,171,199,171.1Zm7,3.7,4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9Zm-6.9,12Zm-14-7.7Zm-7-3.8Zm13.9,5.6,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1Zm3.4-4Zm-.3-.2-4.6,2.9a.9.9,0,0,1-.7.1L185,177l4.6-2.9a.9.9,0,0,1,.7-.1ZM178,173.2l4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1Zm-16.3-8.8-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9C162.1,164.5,161.8,164.5,161.7,164.4Zm-7-3.9-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9C155.1,160.6,154.8,160.6,154.7,160.5Zm5.9-3.3-.3.5h0Zm8.2,11-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9C169.2,168.3,168.9,168.3,168.8,168.2Zm12.3.8-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1Zm-12.7-7.5Zm-5.8,4Zm2.5,2Zm4.5,1.8Zm2.6,2Zm4.4,1.8Zm15.8.8Zm-14-7.7Zm-14-7.5h.1C164.4,158.5,164.4,158.6,164.4,158.7Zm-3-1Zm-10.3,2.1Zm4.4,1.8ZM186.2,179Zm4.4,1.8Zm6.6-10.8h0l.3-.5Zm-12-1.1a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-14-7.7a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-21-10.3h0Zm-2.7.3a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7Zm2.5,8.7Zm8.5,10.5-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9C158.9,170.4,158.6,170.5,158.5,170.4Zm7,3.9-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9C165.9,174.3,165.6,174.4,165.5,174.3Zm7,3.8-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9C172.9,178.1,172.6,178.2,172.5,178.1Zm7,3.8-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9C179.9,181.9,179.6,182,179.5,181.9Zm14,7.7-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9Zm15.9-5,.3-.5-.3.5Zm-3-3h0Zm-14.2-8.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-8-10.4Zm-6,2.7a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-14.1-7.7a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7ZM147.5,150Zm-3.3,7.1a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7Zm7,3.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7Zm35.1,19.2a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7Zm13.9,6.5Zm12-9.2Zm-3-2.2h0Zm-4-1.6Zm-3-2.2h0Zm-4-1.6Zm-10-6.1Zm-11-5.4Zm-3-2.3Zm-7-3.8Zm-7-3.8h0Zm-4.1-1.6Zm-6.2-2.7,4.7,2.6-4.5,2.8a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.8Zm9.4,27.3v.2h0Zm7,3.9Zm7,3.8Zm14,7.7h0Zm7.2,3.7v.2h0Zm10.1-2.1h0Zm5.9-4.1h0Zm8.8-3.1h0Zm4,.5a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-13.1-6.1.3-.5h0Zm-22-13.1a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-14-7.7a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-21-10.2h0Zm-12.7,2.6a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7Zm1,6.6Zm-3.7-.6,4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9C137.4,153.2,137.7,153.2,137.8,153.3Zm5,9.8Zm8.8,4.7.8-.2v.2h0a1.7,1.7,0,0,0-1,0h0C151.4,167.8,151.5,167.8,151.6,167.8Zm35,19.2h0Zm37.9-4.1Zm-8.2-4.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7.1-3.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.8a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.8a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-14-7.7a.9.9,0,0,1-.7.1l-4.9-2.7,4.7-2.8a.9.9,0,0,1,.7-.1l4.8,2.7Zm-14.1-7.7a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-10.9-4.1h0Zm-19.6,13.5,4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9A.6.6,0,0,1,129.6,156.6Zm6.3,3.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7Zm6.9,3.9a.9.9,0,0,1,.7-.1l6.4,3.5-4.6,2.9a.9.9,0,0,1-.7.1l-6.4-3.5Zm8.6,4.7a.9.9,0,0,1,.7-.1L185,186.9l-4.6,2.9a.9.9,0,0,1-.7.1L146.8,172Zm35.1,19.1a.7.7,0,0,1,.6-.1h0l6.4,3.5-4.6,2.9h-.7l-6.4-3.5Zm19.6.4,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1Zm8.7-3.1,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1Zm10-2.4,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1ZM173,148.3Zm-19.9-4.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm-10.2-3.1,4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9A.6.6,0,0,1,142.9,140.3Zm-5.8,11.9Zm-5.9,4h0c-.1-.1,0-.1,0,0Zm-3.6-.6h0l.3-.5Zm67.7,42.8-4.8-2.7,4.6-2.9h.7l4.8,2.7-4.6,2.9Zm6.1-3.8ZM229.3,179h0ZM217,171.6l.3-.5h0Zm-1.9-.2v-.2h1A1.7,1.7,0,0,0,215.1,171.4Zm-6-4Zm-7-3.8Zm-8-3.7h.9A1.5,1.5,0,0,0,194.1,159.9Zm-14-7.7h.9A1.4,1.4,0,0,0,180.1,152.2Zm-12.3-7.5.3-.5h0Zm-1.8-.2h1A1.2,1.2,0,0,0,166,144.5Zm-6-4Zm-13.8.2h-.1C146.1,140.8,146.2,140.7,146.2,140.7Zm-10,2.6Zm-7.4,12.2h0Zm8,11.6Zm8.6,4.7Zm43.7,23.9Zm20.3,10.4-11.9-6.5,4.6-2.9a.9.9,0,0,1,.7-.1l11.9,6.5-4.6,2.9A.9.9,0,0,1,209.4,206.1Zm-2-14.4a.9.9,0,0,1,.7-.1l13.4,7.4-4.6,2.9a.9.9,0,0,1-.7.1l-13.4-7.4Zm10.3-2.2a.9.9,0,0,1,.7-.1l9.9,5.4-4.6,2.9a.9.9,0,0,1-.7.1l-9.9-5.4Zm8.7-3.1a.9.9,0,0,1,.7-.1l8,4.4-4.6,2.9a.9.9,0,0,1-.7.1l-8-4.4Zm10-2.4a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1l-4.8-2.7Zm.8-1.3Zm-.1-1.2a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.9a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.7a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.9a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7.2-3.8a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.8a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.9a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.8a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.9a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.8a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7.1-3.9a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.8a.9.9,0,0,1-.7.1l-4.8-2.7,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7Zm-7-3.9a.9.9,0,0,1-.7.1l-8-4.4,2.2-1.4a.9.9,0,0,1,.7-.1l8,4.4Zm-.4,1.3h.7a1.7,1.7,0,0,0-1,.1h0C152.1,136.7,152.2,136.7,152.4,136.7Zm-6.3,2.8a.9.9,0,0,1-.7.1l-8-4.4,4.6-2.9a.9.9,0,0,1,.7-.1l8,4.4Zm-3.9-.3Zm-6.1,2.9a.9.9,0,0,1-.7.1l-4.8-2.7,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7Zm2.9,4-4.6,2.9a.9.9,0,0,1-.7.1l-9.9-5.4,4.6-2.9a.9.9,0,0,1,.7-.1Zm-3.3,5.9-4.6,2.9a.9.9,0,0,1-.7.1L117,147.7l4.6-2.9a.9.9,0,0,1,.7-.1Zm-25.6-.1,4.6-2.9a.9.9,0,0,1,.7-.1l4.8,2.7-4.6,2.9a.9.9,0,0,1-.7.1Zm12.9,7.5v.2h0Zm72.9,40.1h.3v.2Zm6.1-4Zm36.6-12.8,2.2-1.4a.9.9,0,0,1,.7-.1l4.8,2.7-2.2,1.4a.9.9,0,0,1-.7.1ZM115.8,155.6ZM75.7,166.1l26.7-16.2,111.2,60.7-26.2,15.9c-2.6,1.5-6.4,1.7-8.6.6l-41.9-22.9v-.3a1.1,1.1,0,0,0-.6-1l-16.9-9.3h0a2.1,2.1,0,0,0-1.9,0L75.3,170.4a2,2,0,0,1-1.3-1.7,2.3,2.3,0,0,1,1-2l.7-.4C75.6,166.2,75.7,166.2,75.7,166.1Zm183.5,12h0l-1.8-77.4c-.1-4.3-1.5-6.7-4.8-8.5L148.9,35.5l-1.1-.5h.2a2.9,2.9,0,0,1,2.2.5L253.8,92.1c2.5,1.4,4.1,3.1,4.2,7.5l1.8,77.3c0,1.6-.3,2.5-.8,3A8.2,8.2,0,0,0,259.2,178.1Z"
            transform="translate(-0.5 -2.3)"
          />
        </g>
        <g id="FrontElements">
          <g id="Box6">
            <g id="XMLID_1217" data-name="XMLID 1217">
              <g id="XMLID_1223" data-name="XMLID 1223">
                <g id="XMLID_1234" data-name="XMLID 1234">
                  <path
                    id="XMLID_1238"
                    data-name="XMLID 1238"
                    class="cls-4"
                    d="M251.3,131.1,238,123.5h-.6l-3.4,2,3.2,5.4v-1.7a1.7,1.7,0,0,0,.7,1.4l6.8,4,3.5,5.8,3.5-2.1a.8.8,0,0,0,.2-.6v-5.1A1.4,1.4,0,0,0,251.3,131.1Z"
                    transform="translate(-0.5 -2.3)"
                  />
                  <path
                    id="XMLID_1235"
                    data-name="XMLID 1235"
                    class="cls-6"
                    d="M248.3,140.9l-.3-.4-3.4-5.7-6.7-3.9h-.5l-.3.2-3.3-5.6V125h.2l3.5-2.1h.9l13.3,7.6a2.4,2.4,0,0,1,1,1.8v5.2a1,1,0,0,1-.4.9ZM237,129.2h.8a1.9,1.9,0,0,0,.5,1.1l6.9,4h.1l3.3,5.5,3.1-1.9v-5.5a1.9,1.9,0,0,0-.5-1.1l-13.3-7.5h-.1l-3.1,1.9,2.2,3.8v-.4Z"
                    transform="translate(-0.5 -2.3)"
                  />
                </g>
                <g id="XMLID_1229" data-name="XMLID 1229">
                  <path
                    id="XMLID_1233"
                    data-name="XMLID 1233"
                    class="cls-6"
                    d="M244.3,132.7v1.6l.5.3,3.4,5.8h.1l3.4-2a.8.8,0,0,0,.2-.6v-5.1h-.1l-3.4,2Z"
                    transform="translate(-0.5 -2.3)"
                  />
                  <path
                    id="XMLID_1230"
                    data-name="XMLID 1230"
                    class="cls-6"
                    d="M248.5,140.7h-.4l-3.5-5.8-.6-.4v-1.9l.3-.5,4.5,2,3.4-2,.5.2v5.4a1,1,0,0,1-.4.9Zm-3.7-6.8.4.3h.1l3.3,5.5,3.1-1.9v-4.7l-2.7,1.6v.2l-4.1-1.8Z"
                    transform="translate(-0.5 -2.3)"
                  />
                </g>
                <g id="XMLID_1224" data-name="XMLID 1224">
                  <path
                    id="XMLID_1228"
                    data-name="XMLID 1228"
                    class="cls-7"
                    d="M247.9,140.3l-13.3-7.6a1.7,1.7,0,0,1-.7-1.4v-5.2c0-.5.3-.8.7-.6l13.3,7.6a1.7,1.7,0,0,1,.7,1.4v5.2C248.7,140.3,248.4,140.5,247.9,140.3Z"
                    transform="translate(-0.5 -2.3)"
                  />
                  <path
                    id="XMLID_1225"
                    data-name="XMLID 1225"
                    class="cls-6"
                    d="M248.2,140.8h-.5l-13.3-7.6a2.4,2.4,0,0,1-1-1.8v-5.2a1.2,1.2,0,0,1,.5-1,1,1,0,0,1,.9,0l13.3,7.6a2.4,2.4,0,0,1,1,1.8v5.2a1.2,1.2,0,0,1-.5,1Zm-13.8-15v5.4a1.9,1.9,0,0,0,.5,1.1l13.3,7.6h.1v-5.4a1.9,1.9,0,0,0-.5-1.1Z"
                    transform="translate(-0.5 -2.3)"
                  />
                </g>
              </g>
              <g id="XMLID_1221" data-name="XMLID 1221">
                <path
                  id="XMLID_1222"
                  data-name="XMLID 1222"
                  class="cls-6"
                  d="M239.7,124.4l-3.3,2,.4.7,3.3-2Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_1218" data-name="XMLID 1218">
                <path
                  id="XMLID_1220"
                  data-name="XMLID 1220"
                  class="cls-7"
                  d="M251.6,135.5l-2.9,1.7.4.6,2.9-1.7Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
            </g>
            <g id="XMLID_1191" data-name="XMLID 1191">
              <g id="XMLID_1192" data-name="XMLID 1192">
                <g id="XMLID_1197" data-name="XMLID 1197">
                  <g id="XMLID_1212" data-name="XMLID 1212">
                    <path
                      id="XMLID_1216"
                      data-name="XMLID 1216"
                      class="cls-4"
                      d="M251.2,112.4l-13.3-7.6h-.6l-3.4,2,3.2,5.4v7.4a1.7,1.7,0,0,0,.7,1.4l6.8,4,3.5,5.8,3.5-2.1a.8.8,0,0,0,.2-.6V114A1.7,1.7,0,0,0,251.2,112.4Z"
                      transform="translate(-0.5 -2.3)"
                    />
                    <path
                      id="XMLID_1213"
                      data-name="XMLID 1213"
                      class="cls-6"
                      d="M248.4,131.2H248v-.2l-3.4-5.7-6.7-3.9a2.4,2.4,0,0,1-1-1.8v-7.2l-3.4-5.7.4-.3,3.5-2.1a1,1,0,0,1,.9,0l13.3,7.6a2.4,2.4,0,0,1,1,1.8v14.2a1,1,0,0,1-.4.9ZM234.6,107l3.1,5.2h0v7.3a1.9,1.9,0,0,0,.5,1.1l6.9,4h.1l3.3,5.5,3.1-1.9V114a1.9,1.9,0,0,0-.5-1.1l-13.3-7.6h-.1Z"
                      transform="translate(-0.5 -2.3)"
                    />
                  </g>
                  <g id="XMLID_1203" data-name="XMLID 1203">
                    <path
                      id="XMLID_1211"
                      data-name="XMLID 1211"
                      class="cls-6"
                      d="M244.2,123v1.6l.5.3,3.4,5.8h.1l3.4-2a.8.8,0,0,0,.2-.6V113.9h-.1l-3.4,2Z"
                      transform="translate(-0.5 -2.3)"
                    />
                    <path
                      id="XMLID_1204"
                      data-name="XMLID 1204"
                      class="cls-6"
                      d="M248.4,131.2h-.3l-.2-.2-3.4-5.7-.6-.4v-1.9h.1l4.4-7.2h.1l3.6-2.2.5.2V128a1,1,0,0,1-.4.9Zm-3.7-6.9.4.2h.1l3.3,5.5,3.1-1.9V114.6l-2.7,1.6-4.3,6.9Z"
                      transform="translate(-0.5 -2.3)"
                    />
                  </g>
                  <g id="XMLID_1198" data-name="XMLID 1198">
                    <path
                      id="XMLID_1202"
                      data-name="XMLID 1202"
                      class="cls-7"
                      d="M247.8,130.7l-13.3-7.6a1.7,1.7,0,0,1-.7-1.4V107.4c0-.5.3-.8.7-.6l13.3,7.6a1.7,1.7,0,0,1,.7,1.4V130C248.6,130.7,248.2,130.9,247.8,130.7Z"
                      transform="translate(-0.5 -2.3)"
                    />
                    <path
                      id="XMLID_1199"
                      data-name="XMLID 1199"
                      class="cls-6"
                      d="M248.1,131.2h-.5l-13.3-7.6a2.4,2.4,0,0,1-1-1.8V107.4a1.2,1.2,0,0,1,.5-1,1,1,0,0,1,.9,0L248,114a2.4,2.4,0,0,1,1,1.8V130a1.2,1.2,0,0,1-.5,1C248.4,131.2,248.3,131.2,248.1,131.2Zm-13.8-24v14.4a1.9,1.9,0,0,0,.5,1.1l13.3,7.6h.1V115.9a1.9,1.9,0,0,0-.5-1.1Z"
                      transform="translate(-0.5 -2.3)"
                    />
                  </g>
                </g>
                <g id="XMLID_1195" data-name="XMLID 1195">
                  <path
                    id="XMLID_1196"
                    data-name="XMLID 1196"
                    class="cls-6"
                    d="M239.5,105.8l-3.3,2,.4.7,3.3-2Z"
                    transform="translate(-0.5 -2.3)"
                  />
                </g>
                <g id="XMLID_1193" data-name="XMLID 1193">
                  <path
                    id="XMLID_1194"
                    data-name="XMLID 1194"
                    class="cls-7"
                    d="M251.5,125.9l-2.9,1.7.4.6,2.9-1.7Z"
                    transform="translate(-0.5 -2.3)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Box5">
            <g id="XMLID_1173" data-name="XMLID 1173">
              <g id="XMLID_1185" data-name="XMLID 1185">
                <path
                  id="XMLID_1189"
                  data-name="XMLID 1189"
                  class="cls-4"
                  d="M211,69.3l-4.2-2.4a.2.2,0,0,0-.3,0L203.2,69c-.1,0-.1.1,0,.2l3.2,3.4h0v1.1a1,1,0,0,0,.4.8l1.1-1.3-.2,1.8c0,.1.1.1.2,0l3.3-2.1V70.1A.8.8,0,0,0,211,69.3Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_1186"
                  data-name="XMLID 1186"
                  class="cls-6"
                  d="M207.8,75.5h0c-.2,0-.4-.1-.4-.3h-.1v-.7l-.5.6-.3-.2a1.4,1.4,0,0,1-.7-1.2v-1l-3.2-3.4a.5.5,0,0,1,.2-.8l3.3-2.1h.7l4.2,2.4a1.4,1.4,0,0,1,.7,1.2v2.6a1.3,1.3,0,0,1-.2.6h-.1l-3.3,2.1Zm0-2.8.3.2.2.2h.1v1.3l2.7-1.7h0V70.1a.8.8,0,0,0-.2-.5l-4.2-2.4L203.7,69l3,3.2a.4.4,0,0,1,.1.3v1.3Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_1180" data-name="XMLID 1180">
                <path
                  id="XMLID_1184"
                  data-name="XMLID 1184"
                  class="cls-6"
                  d="M205.4,72.9v.2l2.3,2h.3l3.3-2V70.4a.1.1,0,0,0-.1-.1L208,72.4Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_1181"
                  data-name="XMLID 1181"
                  class="cls-6"
                  d="M207.9,75.5h-.2l-.4-.2-2.5-2.1v-.7l2.8-.6,3.3-2.1h.5a.5.5,0,0,1,.3.4v2.5a1.3,1.3,0,0,1-.2.6h-.1l-3.3,2Zm-1.8-2.4,1.8,1.5,3.1-1.9h0V70.7l-2.7,1.7h-.1Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_1174" data-name="XMLID 1174">
                <path
                  id="XMLID_1179"
                  data-name="XMLID 1179"
                  class="cls-7"
                  d="M207.5,75.2l-4.2-2.4a1,1,0,0,1-.4-.8V69.4c0-.3.2-.5.4-.3l4.2,2.4a1,1,0,0,1,.4.8v2.6C207.9,75.2,207.7,75.4,207.5,75.2Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_1175"
                  data-name="XMLID 1175"
                  class="cls-6"
                  d="M207.7,75.6h-.4l-4.2-2.4a1.4,1.4,0,0,1-.7-1.2V69.3a.7.7,0,0,1,.4-.7h.7l4.2,2.4a1.4,1.4,0,0,1,.7,1.2v2.6a.7.7,0,0,1-.4.7Zm0-.7-.2.4Zm-4.3-5.4V72a.8.8,0,0,0,.2.5l4,2.3V72.3a.8.8,0,0,0-.2-.5Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
            </g>
            <g id="XMLID_1171" data-name="XMLID 1171">
              <path
                id="XMLID_1172"
                data-name="XMLID 1172"
                class="cls-6"
                d="M208.4,67.5l-3.3,2,.4.7,3.3-2Z"
                transform="translate(-0.5 -2.3)"
              />
            </g>
            <g id="XMLID_1169" data-name="XMLID 1169">
              <path
                id="XMLID_1170"
                data-name="XMLID 1170"
                class="cls-7"
                d="M211,71.8l-2.9,1.7.4.6,2.9-1.7Z"
                transform="translate(-0.5 -2.3)"
              />
            </g>
          </g>
          <g id="Box4">
            <g id="XMLID_1149" data-name="XMLID 1149">
              <g id="XMLID_1163" data-name="XMLID 1163">
                <path
                  id="XMLID_1167"
                  data-name="XMLID 1167"
                  class="cls-4"
                  d="M240.4,86.4l-24-14a.2.2,0,0,0-.3,0l-3.3,2.1c-.1,0-.1.1,0,.2l3.2,3.4h0v1.1a1,1,0,0,0,.4.8l1.1-1.3,19.7,13.4h.2l3.3-2.1a1,1,0,0,0,.1-.3V87.2A.7.7,0,0,0,240.4,86.4Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_1164"
                  data-name="XMLID 1164"
                  class="cls-6"
                  d="M237.4,92.6h0l-.4-.2L217.6,79.2l-1.1,1.3-.3-.2a1.4,1.4,0,0,1-.7-1.2v-1l-3.2-3.4a.5.5,0,0,1,.2-.8l3.3-2.1h.7l24,14a1.4,1.4,0,0,1,.7,1.2v2.8a1.3,1.3,0,0,1-.2.6h-.1l-3.3,2.1ZM217.8,78.4l19.5,13.3,3.1-1.9h0V87.1a.8.8,0,0,0-.2-.5l-24-13.9-2.9,1.8,3,3.2a.4.4,0,0,1,.1.3v1.3l1-1.2.4.3Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_1158" data-name="XMLID 1158">
                <path
                  id="XMLID_1162"
                  data-name="XMLID 1162"
                  class="cls-6"
                  d="M218.7,80.5l16.2,9.6,2.3,2h.3l3.3-2V87.4a.1.1,0,0,0-.1-.1l-3.3,2.1L221.2,80Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_1159"
                  data-name="XMLID 1159"
                  class="cls-6"
                  d="M237.5,92.6h-.2l-.4-.2-2.3-2c-.8-.6-9.9-5.9-16.1-9.5l-.9-.5,3.8-.9h.1l16,9.3,3.1-1.9h.5a.5.5,0,0,1,.3.4v2.4a1.3,1.3,0,0,1-.2.6h-.1l-3.3,2Zm-2.3-2.8,2.3,1.9,3.1-1.9h0V87.8l-2.8,1.7c-.2.1-.2.1-2.5-1.2l-14.1-8.1-1.4.3C231.7,87.6,234.5,89.2,235.2,89.8Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_1150" data-name="XMLID 1150">
                <path
                  id="XMLID_1157"
                  data-name="XMLID 1157"
                  class="cls-7"
                  d="M237.1,92.2l-24-14a1,1,0,0,1-.4-.8V74.8c0-.3.2-.5.4-.3l24,14a1,1,0,0,1,.4.8v2.6C237.5,92.2,237.3,92.4,237.1,92.2Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_1151"
                  data-name="XMLID 1151"
                  class="cls-6"
                  d="M237.2,92.7h-.4l-24-14a1.4,1.4,0,0,1-.7-1.2V74.8a.7.7,0,0,1,.4-.7h.7l24,14a1.4,1.4,0,0,1,.7,1.2v2.6a.7.7,0,0,1-.4.7C237.5,92.7,237.4,92.7,237.2,92.7Zm.1-.8-.2.4ZM213,75v2.5a.8.8,0,0,0,.2.5L237,91.8V89.3a.8.8,0,0,0-.2-.5Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
            </g>
            <g id="XMLID_1147" data-name="XMLID 1147">
              <path
                id="XMLID_1148"
                data-name="XMLID 1148"
                class="cls-6"
                d="M218,73.1l-3.3,2,.4.7,3.3-2Z"
                transform="translate(-0.5 -2.3)"
              />
            </g>
            <g id="XMLID_1136" data-name="XMLID 1136">
              <path
                id="XMLID_1137"
                data-name="XMLID 1137"
                class="cls-7"
                d="M240.5,88.8l-2.9,1.7.4.6,2.9-1.7Z"
                transform="translate(-0.5 -2.3)"
              />
            </g>
          </g>
          <g id="Box3">
            <g id="XMLID_1109" data-name="XMLID 1109">
              <g id="XMLID_1114" data-name="XMLID 1114">
                <g id="XMLID_1127" data-name="XMLID 1127">
                  <path
                    id="XMLID_1134"
                    data-name="XMLID 1134"
                    class="cls-4"
                    d="M186.3,132.9l-8.8-5.1h-.3l-3.7,2.3c-.1,0-.1.1,0,.2l3.6,3.9h0v1.2a.9.9,0,0,0,.5.9l1.2-1.5h.1l4,4.5h.2l3.7-2.3a.7.7,0,0,0,.2-.4V134C186.7,133.3,186.5,132.9,186.3,132.9Z"
                    transform="translate(-0.5 -2.3)"
                  />
                  <path
                    id="XMLID_1131"
                    data-name="XMLID 1131"
                    class="cls-6"
                    d="M182.8,139.8h0a.5.5,0,0,1-.4-.2l-3.7-4.1-1.2,1.4-.3-.2a1.6,1.6,0,0,1-.7-1.3v-1.1l-3.6-3.8a.5.5,0,0,1,.2-.8l3.7-2.3a1.1,1.1,0,0,1,.8,0l8.8,5.1a1.6,1.6,0,0,1,.7,1.3v2.9a1.1,1.1,0,0,1-.3.7h-.1l-3.7,2.3Zm-3.7-5.2,3.8,4.3,3.5-2.2h0v-2.9a1.1,1.1,0,0,0-.3-.6l-8.7-5.1-3.4,2.1,3.4,3.7a.4.4,0,0,1,.1.3v1.2a.4.4,0,0,0,.1.3l1.1-1.4.3.2Z"
                    transform="translate(-0.5 -2.3)"
                  />
                </g>
                <g id="XMLID_1120" data-name="XMLID 1120">
                  <path
                    id="XMLID_1124"
                    data-name="XMLID 1124"
                    class="cls-6"
                    d="M180.1,136.8v.2l2.6,2.2c.1.1.2.2.3.1l3.7-2.3a.7.7,0,0,0,.2-.4v-2.8c0-.1-.1-.1-.2-.1L183,136Z"
                    transform="translate(-0.5 -2.3)"
                  />
                  <path
                    id="XMLID_1121"
                    data-name="XMLID 1121"
                    class="cls-6"
                    d="M182.8,139.8h-.2l-.4-.2-2.7-2.3v-.8l3.1-.7,3.7-2.3h.5a.5.5,0,0,1,.3.5v2.8a1.1,1.1,0,0,1-.3.7h-.1l-3.7,2.3C183.1,139.7,183,139.8,182.8,139.8Zm-2-2.7,2.2,1.8,3.5-2.2h0v-2.2l-3.1,2h-.1Z"
                    transform="translate(-0.5 -2.3)"
                  />
                </g>
                <g id="XMLID_1115" data-name="XMLID 1115">
                  <path
                    id="XMLID_1119"
                    data-name="XMLID 1119"
                    class="cls-7"
                    d="M182.4,139.4l-8.8-5.1a1.2,1.2,0,0,1-.5-.9v-3c0-.4.2-.5.5-.4l8.8,5.1a1.2,1.2,0,0,1,.5.9v2.9C182.9,139.4,182.7,139.6,182.4,139.4Z"
                    transform="translate(-0.5 -2.3)"
                  />
                  <path
                    id="XMLID_1116"
                    data-name="XMLID 1116"
                    class="cls-6"
                    d="M182.6,139.9h-.4l-8.8-5.1a1.6,1.6,0,0,1-.7-1.3v-3a.9.9,0,0,1,.4-.8h.7l8.8,5.1a1.6,1.6,0,0,1,.7,1.3v2.9a.9.9,0,0,1-.4.8C182.8,139.9,182.7,139.9,182.6,139.9Zm-9.1-9.3v2.9a1.1,1.1,0,0,0,.3.6l8.6,5v-2.9a1.1,1.1,0,0,0-.3-.6Z"
                    transform="translate(-0.5 -2.3)"
                  />
                </g>
              </g>
              <g id="XMLID_1112" data-name="XMLID 1112">
                <path
                  id="XMLID_1113"
                  data-name="XMLID 1113"
                  class="cls-6"
                  d="M179.3,128.6l-3.7,2.3.4.7,3.7-2.3Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_1110" data-name="XMLID 1110">
                <path
                  id="XMLID_1111"
                  data-name="XMLID 1111"
                  class="cls-7"
                  d="M186.3,135.6l-3.2,1.9.4.6,3.2-1.9Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
            </g>
            <g id="XMLID_1075" data-name="XMLID 1075">
              <g id="XMLID_1087" data-name="XMLID 1087">
                <g id="XMLID_1088" data-name="XMLID 1088">
                  <g id="XMLID_1093" data-name="XMLID 1093">
                    <g id="XMLID_1104" data-name="XMLID 1104">
                      <path
                        id="XMLID_1108"
                        data-name="XMLID 1108"
                        class="cls-4"
                        d="M185.9,87.9,149.5,67h-.6l-3.7,2.2a.4.4,0,0,0-.1.3l3.5,6h0v31.7a2.3,2.3,0,0,0,.8,1.6l29.5,17h.1l3.4,5.9h.3l3.7-2.2c.2-.1.3-.3.3-.7V89.5A2.3,2.3,0,0,0,185.9,87.9Z"
                        transform="translate(-0.5 -2.3)"
                      />
                      <path
                        id="XMLID_1105"
                        data-name="XMLID 1105"
                        class="cls-6"
                        d="M182.7,132.4h-.2c-.2,0-.3-.1-.4-.3l-3.4-5.9-29.4-17a2.3,2.3,0,0,1-1-2V75.6l-3.4-5.9a.5.5,0,0,1,.2-.8l3.7-2.2a.9.9,0,0,1,1,0l36.3,20.9a2.3,2.3,0,0,1,1,2v39.6a1.5,1.5,0,0,1-.4,1l-3.7,2.2Zm-36.9-63,3.3,5.8a.4.4,0,0,1,.1.3v31.7a1.6,1.6,0,0,0,.6,1.2l29.5,17,.2.2,3.3,5.8,3.5-2.1a.4.4,0,0,0,.1-.3V89.5a1.6,1.6,0,0,0-.6-1.2L149.5,67.4h-.1Z"
                        transform="translate(-0.5 -2.3)"
                      />
                    </g>
                    <g id="XMLID_1099" data-name="XMLID 1099">
                      <path
                        id="XMLID_1103"
                        data-name="XMLID 1103"
                        class="cls-6"
                        d="M161.1,92.9c.1.5,1.4,17.7,2.6,24.1l15.3,8.7h.1l3.4,5.9c.1.1.2.2.3.1l3.6-2.1c.2-.1.3-.3.3-.7V89.6h-.1l-3.8,2.3Z"
                        transform="translate(-0.5 -2.3)"
                      />
                      <path
                        id="XMLID_1100"
                        data-name="XMLID 1100"
                        class="cls-6"
                        d="M182.7,132.4h-.2c-.2,0-.3-.2-.4-.3l-3.4-5.8-15.5-8.8v-.2c-1-5-2-16.7-2.4-21.6-.1-1.3-.2-2.3-.2-2.5l.5-.2h-.4v-.3l.3-.3,21.8-1.1,3.9-2.3h.3a.5.5,0,0,1,.2.4v39.5a1.5,1.5,0,0,1-.4,1l-3.7,2.2Zm-18.6-15.7,15.3,8.8.2.2,3.3,5.8,3.5-2.1a.4.4,0,0,0,.1-.3V90.2l-3.3,2H183l-21.3,1c0,.4.1,1,.2,2.1A194,194,0,0,0,164.1,116.7Z"
                        transform="translate(-0.5 -2.3)"
                      />
                    </g>
                    <g id="XMLID_1094" data-name="XMLID 1094">
                      <path
                        id="XMLID_1098"
                        data-name="XMLID 1098"
                        class="cls-7"
                        d="M182.1,132.1l-36.3-20.9a1.9,1.9,0,0,1-.8-1.6V70c0-.6.4-.9.8-.6l36.3,20.9a1.9,1.9,0,0,1,.8,1.6v39.6C182.8,132,182.4,132.3,182.1,132.1Z"
                        transform="translate(-0.5 -2.3)"
                      />
                      <path
                        id="XMLID_1095"
                        data-name="XMLID 1095"
                        class="cls-6"
                        d="M182.3,132.6l-.5-.2-36.3-20.9a2.3,2.3,0,0,1-1-2V70a1,1,0,0,1,.5-1c.3-.2.6-.1,1,0l36.2,20.8a2.3,2.3,0,0,1,1,2v39.6a1,1,0,0,1-.5,1ZM145.4,69.7a.4.4,0,0,0-.1.3v39.6a1.6,1.6,0,0,0,.6,1.2l36.3,20.9h.1a.4.4,0,0,0,.1-.3V91.8a1.6,1.6,0,0,0-.6-1.2L145.4,69.7Z"
                        transform="translate(-0.5 -2.3)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_1091" data-name="XMLID 1091">
                    <path
                      id="XMLID_1092"
                      data-name="XMLID 1092"
                      class="cls-6"
                      d="M151.8,68.1l-3.7,2.3.4.7,3.7-2.3Z"
                      transform="translate(-0.5 -2.3)"
                    />
                  </g>
                  <g id="XMLID_1089" data-name="XMLID 1089">
                    <path
                      id="XMLID_1090"
                      data-name="XMLID 1090"
                      class="cls-7"
                      d="M186.3,125l-3.2,1.9.4.6,3.2-1.9Z"
                      transform="translate(-0.5 -2.3)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_1080" data-name="XMLID 1080">
                <path
                  id="XMLID_1081"
                  data-name="XMLID 1081"
                  class="cls-4"
                  d="M166.4,112.2l-3.9-2.2v-2a17,17,0,0,1-3.3-4.1h-1.6l-1.9-4.8h1.7a8.6,8.6,0,0,1-.2-2.2,6.9,6.9,0,0,1,.3-2l-1.6-2,2-2.8,1.7,2.1a3.9,3.9,0,0,1,3-.3V89.7l3.9,2.2V94a17,17,0,0,1,3.3,4.1h1.6l1.9,4.8h-1.7a8.6,8.6,0,0,1,.2,2.2,6.9,6.9,0,0,1-.3,2l1.6,2-2,2.8-1.7-2.1a3.9,3.9,0,0,1-3,.3Zm-3.2-2.5,2.6,1.5v-2h.4a3.5,3.5,0,0,0,3.2-.3l.2-.2,1.5,1.8,1.2-1.7-1.5-1.9v-.2a6.9,6.9,0,0,0,.3-2,12,12,0,0,0-.3-2.4V102h1.5l-1.4-3.5h-1.5v-.2a15.7,15.7,0,0,0-3.4-4.2h-.1V92l-2.6-1.5v2h-.4a3.5,3.5,0,0,0-3.2.3l-.2.2-1.5-1.8-1.2,1.7,1.5,1.9v.2a6.9,6.9,0,0,0-.3,2,12,12,0,0,0,.3,2.4v.4h-1.5l1.4,3.5h1.5v.2a15.7,15.7,0,0,0,3.4,4.2h.1Zm2.6-4.7h-.7c-2.3-.7-4.3-4.1-3.7-6.4a2.1,2.1,0,0,1,.9-1.3,1.8,1.8,0,0,1,1.6-.1c2.3.7,4.3,4.1,3.7,6.4a2.1,2.1,0,0,1-.9,1.3Zm-2.6-7.4h-.6a1.5,1.5,0,0,0-.6.9c-.5,2,1.3,5.1,3.3,5.7a1.4,1.4,0,0,0,1.1-.1,1.5,1.5,0,0,0,.6-.9c.5-2-1.3-5.1-3.3-5.7Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_1076" data-name="XMLID 1076">
                <path
                  id="XMLID_1077"
                  data-name="XMLID 1077"
                  class="cls-6"
                  d="M170.4,105.6a11.3,11.3,0,0,0-.3-2.5h1.6l-1.6-4.2h-1.6a17.9,17.9,0,0,0-3.4-4.3V92.5l-3.2-1.9v2.1a3.9,3.9,0,0,0-3.4.3l-1.6-2-1.6,2.3,1.6,2a6.6,6.6,0,0,0-.3,2.1,11.3,11.3,0,0,0,.3,2.5h-1.6l1.6,4.2h1.6a17.9,17.9,0,0,0,3.4,4.3v2.1l3.2,1.9v-2.1a3.9,3.9,0,0,0,3.4-.3l1.6,2,1.6-2.3-1.6-2A7.1,7.1,0,0,0,170.4,105.6Zm-6.2-.4c-2.1-.6-4-3.9-3.5-6a1.6,1.6,0,0,1,2.1-1.2c2.1.6,4,3.9,3.5,6A1.6,1.6,0,0,1,164.2,105.2Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
            </g>
            <g id="XMLID_988" data-name="XMLID 988">
              <g id="XMLID_1038" data-name="XMLID 1038">
                <g id="XMLID_1039" data-name="XMLID 1039">
                  <g id="XMLID_1047" data-name="XMLID 1047">
                    <g id="XMLID_1068" data-name="XMLID 1068">
                      <path
                        id="XMLID_1074"
                        data-name="XMLID 1074"
                        class="cls-4"
                        d="M156.4,65l-14.9-8.5a.4.4,0,0,0-.5,0h-.1l-3.8,2.3,3.6,6V73a2.3,2.3,0,0,0,.8,1.6l7.6,4.5,3.9,6.4,3.9-2.3c.2-.1.3-.3.3-.7V66.6A1.9,1.9,0,0,0,156.4,65Z"
                        transform="translate(-0.5 -2.3)"
                      />
                      <path
                        id="XMLID_1071"
                        data-name="XMLID 1071"
                        class="cls-6"
                        d="M152.9,86.1l-.3-.4-3.8-6.3L141.3,75a2.3,2.3,0,0,1-1-2V64.9l-3.7-6v-.4h.2l3.9-2.3c.3-.2.6-.1,1,0l14.9,8.5a2.3,2.3,0,0,1,1,2V82.5a1.5,1.5,0,0,1-.4,1ZM137.6,58.9l3.5,5.8h0V73a1.6,1.6,0,0,0,.6,1.2l7.7,4.5h.1l3.7,6.1,3.6-2.1V66.6a1.6,1.6,0,0,0-.6-1.2l-14.9-8.5h-.1Z"
                        transform="translate(-0.5 -2.3)"
                      />
                    </g>
                    <g id="XMLID_1057" data-name="XMLID 1057">
                      <path
                        id="XMLID_1067"
                        data-name="XMLID 1067"
                        class="cls-6"
                        d="M148.4,76.8v1.8l.6.3,3.9,6.4h.1L157,83c.2-.1.3-.3.3-.7V66.5h-.1l-3.8,2.3Z"
                        transform="translate(-0.5 -2.3)"
                      />
                      <path
                        id="XMLID_1062"
                        data-name="XMLID 1062"
                        class="cls-6"
                        d="M153.2,85.9h-.4l-3.9-6.4-.7-.4V76.9h.1l5-8h.1l4-2.4h.3a.5.5,0,0,1,.2.4V82.7a1.5,1.5,0,0,1-.4,1Zm-4.3-7.5.5.3h.1l3.7,6.1,3.6-2.1V67.3l-3.2,1.9-4.8,7.7Z"
                        transform="translate(-0.5 -2.3)"
                      />
                    </g>
                    <g id="XMLID_1048" data-name="XMLID 1048">
                      <path
                        id="XMLID_1052"
                        data-name="XMLID 1052"
                        class="cls-7"
                        d="M152.5,85.5,137.6,77a1.9,1.9,0,0,1-.8-1.6V59.5c0-.6.4-.9.8-.6l14.9,8.5a1.9,1.9,0,0,1,.8,1.6V84.9C153.3,85.4,153,85.7,152.5,85.5Z"
                        transform="translate(-0.5 -2.3)"
                      />
                      <path
                        id="XMLID_1049"
                        data-name="XMLID 1049"
                        class="cls-6"
                        d="M152.8,86l-.5-.2-14.9-8.5a2.3,2.3,0,0,1-1-2V59.4a1,1,0,0,1,.5-1c.3-.2.6-.1,1,0l14.9,8.5a2.3,2.3,0,0,1,1,2V84.8a1,1,0,0,1-.5,1Zm-.1-.9h0c.1,0,.2-.1.2-.3V68.9a1.6,1.6,0,0,0-.6-1.2l-14.9-8.5h-.1a.4.4,0,0,0-.1.3V75.4a1.6,1.6,0,0,0,.6,1.2Z"
                        transform="translate(-0.5 -2.3)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_1042" data-name="XMLID 1042">
                    <path
                      id="XMLID_1043"
                      data-name="XMLID 1043"
                      class="cls-6"
                      d="M143.3,57.5l-3.7,2.3.4.7,3.7-2.3Z"
                      transform="translate(-0.5 -2.3)"
                    />
                  </g>
                  <g id="XMLID_1040" data-name="XMLID 1040">
                    <path
                      id="XMLID_1041"
                      data-name="XMLID 1041"
                      class="cls-7"
                      d="M156.8,80.2l-3.2,1.9.4.6,3.2-1.9Z"
                      transform="translate(-0.5 -2.3)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_1032" data-name="XMLID 1032">
                <path
                  id="XMLID_1033"
                  data-name="XMLID 1033"
                  class="cls-4"
                  d="M146.8,78l-2.3-1.3V75.6a8.3,8.3,0,0,1-1.6-2h-.8L141,71h.9a3.8,3.8,0,0,1-.1-1,3.4,3.4,0,0,1,.1-1l-.9-1.1,1.2-1.7.9,1.1a1.9,1.9,0,0,1,1.3-.1V66l2.3,1.3v1.1a8.3,8.3,0,0,1,1.6,2h.8l1.1,2.7h-.9a3.8,3.8,0,0,1,.1,1,3.4,3.4,0,0,1-.1,1l.9,1.1L149,77.9l-.9-1.1a1.9,1.9,0,0,1-1.3.1Zm-1.7-1.7,1,.6v-1h.4a1.9,1.9,0,0,0,1.5-.1l.2-.2.7.9.4-.6-.8-.9h0a3.1,3.1,0,0,0,.1-1,3,3,0,0,0-.2-1.2v-.4h.7l-.3-1.3h-.8v-.2a6.8,6.8,0,0,0-1.7-2.1H146v-1l-1-.6V68h-.4a1.9,1.9,0,0,0-1.5.1l-.2.2-.7-.9-.4.6.8.9V69a3.1,3.1,0,0,0-.1,1,3,3,0,0,0,.2,1.2v.4h-.7l.6,1.5h.8v.2a8.7,8.7,0,0,0,1.7,2.1h.1v.9h-.3Zm1.2-2h-.4a3.3,3.3,0,0,1-2-3.5,2.2,2.2,0,0,1,.5-.8,1,1,0,0,1,.9-.1,3.3,3.3,0,0,1,2,3.5,2.2,2.2,0,0,1-.5.8Zm-.2-.7c.1,0,.3.1.4,0s.2-.2.2-.3a2.8,2.8,0,0,0-1.5-2.7h-.4c-.1.1-.2.2-.2.3A2.6,2.6,0,0,0,146.1,73.6Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_995" data-name="XMLID 995">
                <path
                  id="XMLID_999"
                  data-name="XMLID 999"
                  class="cls-6"
                  d="M148,74.7a5,5,0,0,0-.2-1.2h.8l-.8-2.1H147a12.8,12.8,0,0,0-1.7-2.2V68.1l-1.6-.9v1.1a1.9,1.9,0,0,0-1.7.2l-.8-1-.8,1.2.8,1a3.6,3.6,0,0,0-.2,1.1,5,5,0,0,0,.2,1.2h-.8l.8,2.1h.8a12.8,12.8,0,0,0,1.7,2.2v1.1l1.6.9V77.2A1.9,1.9,0,0,0,147,77l.8,1,.8-1.2-.8-1A2.3,2.3,0,0,0,148,74.7Zm-3-.2a3.1,3.1,0,0,1-1.8-3.1.7.7,0,0,1,1-.6,3.1,3.1,0,0,1,1.8,3.1A.8.8,0,0,1,145,74.5Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
            </g>
          </g>
          <g id="Box2">
            <g id="XMLID_592" data-name="XMLID 592">
              <g id="XMLID_660" data-name="XMLID 660">
                <path
                  id="XMLID_711"
                  data-name="XMLID 711"
                  class="cls-4"
                  d="M255.8,151.5l-3.2-2h-.5l-3.3,1.9c-.1,0-.1.1-.1.2l3.1,5.4h0v5.8a1.7,1.7,0,0,0,.7,1.4l-2.9-1.6h.1l3.1,5.4c0,.1.1.1.2.1l3.3-1.9a.8.8,0,0,0,.2-.6V153A2,2,0,0,0,255.8,151.5Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_694"
                  data-name="XMLID 694"
                  class="cls-6"
                  d="M252.9,168.6h0a.5.5,0,0,1-.5-.3l-3.1-5.4h.1l.4-.7,1.6.8v-6l-3.1-5.4a.5.5,0,0,1,.2-.8l3.3-1.9a.9.9,0,0,1,1,0l3.2,2a2.4,2.4,0,0,1,1,1.8v12.8a1,1,0,0,1-.4.9l-3.3,2Zm-2-4.7,2.2,3.9,3.1-1.8V153a1.9,1.9,0,0,0-.5-1.1l-3.2-2h-.1l-3.1,1.8,3,5.2a.4.4,0,0,1,.1.3V163a1.9,1.9,0,0,0,.5,1.1l-.4.7Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_612" data-name="XMLID 612">
                <path
                  id="XMLID_649"
                  data-name="XMLID 649"
                  class="cls-6"
                  d="M249.6,161.6s1.2-6.9,2.4-1l-2.3,2.2h.1l3,5.3h.3l3.2-1.9a.8.8,0,0,0,.2-.6V153.1h-.1l-3.4,2Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_616"
                  data-name="XMLID 616"
                  class="cls-6"
                  d="M252.9,168.6h-.2c-.2,0-.3-.2-.4-.3l-3-5.3h-.1l-.5,1.2.4-2.6c.4-2.5,1-3.8,1.8-3.8h.2l1.8-3.2,3.6-2.1h.3a.5.5,0,0,1,.2.4v12.7a1,1,0,0,1-.4.9l-3.3,1.9C253.2,168.6,253.1,168.6,252.9,168.6Zm-2.6-5.8,2.8,5,3.1-1.8V153.8l-2.7,1.6-1.7,3.2a9.3,9.3,0,0,1,.6,2.1v.2Zm.9-3.4-1.4,2.6,1.6-1.6A4.4,4.4,0,0,1,251.2,159.4Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_595" data-name="XMLID 595">
                <path
                  id="XMLID_609"
                  data-name="XMLID 609"
                  class="cls-7"
                  d="M252.3,168.3l-3.2-2a1.7,1.7,0,0,1-.7-1.4V152.1c0-.5.3-.8.7-.6l3.2,2a1.7,1.7,0,0,1,.7,1.4v12.8C253.1,168.3,252.7,168.5,252.3,168.3Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_599"
                  data-name="XMLID 599"
                  class="cls-6"
                  d="M252.6,168.8h-.5l-3.2-2a2.3,2.3,0,0,1-.9-1.8V152.1a1.2,1.2,0,0,1,.5-1,1,1,0,0,1,.9,0l3.2,2a2.3,2.3,0,0,1,.9,1.8v12.8a1.2,1.2,0,0,1-.5,1Zm-.1-.9h0c.1,0,.1,0,.1-.2V155a1.9,1.9,0,0,0-.5-1.1l-3.2-2h-.1v13a1.9,1.9,0,0,0,.5,1.1Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
            </g>
            <g id="XMLID_585" data-name="XMLID 585">
              <path
                id="XMLID_588"
                data-name="XMLID 588"
                class="cls-6"
                d="M254.6,150.5l-3.3,2,.4.7,3.3-2Z"
                transform="translate(-0.5 -2.3)"
              />
            </g>
            <g id="XMLID_578" data-name="XMLID 578">
              <path
                id="XMLID_582"
                data-name="XMLID 582"
                class="cls-7"
                d="M256.1,162.1l-2.9,1.7.4.6,2.9-1.7Z"
                transform="translate(-0.5 -2.3)"
              />
            </g>
          </g>
          <g id="Box1">
            <g id="XMLID_465" data-name="XMLID 465">
              <g id="XMLID_556" data-name="XMLID 556">
                <path
                  id="XMLID_572"
                  data-name="XMLID 572"
                  class="cls-4"
                  d="M131,45.3l-3.2-2h-.5l-3.4,1.9c-.1,0-.1.1-.1.2l3.1,5.4h0v.6a1.7,1.7,0,0,0,.7,1.4l-2.8-1.5h.1l3.1,5.4c0,.1.1.1.2.1l3.3-1.9a.8.8,0,0,0,.2-.6V46.9A1.9,1.9,0,0,0,131,45.3Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_561"
                  data-name="XMLID 561"
                  class="cls-6"
                  d="M128.1,57.3h-.2c-.2,0-.3-.1-.4-.3l-3.1-5.4h.1l.4-.7,1.6.8V51l-3.1-5.4a.5.5,0,0,1,.2-.8l3.3-1.9a.9.9,0,0,1,1,0l3.2,2a2.4,2.4,0,0,1,1,1.8v7.6a1,1,0,0,1-.4.9l-3.3,2ZM126,52.4l2.2,3.9,3.1-1.8V46.7a1.9,1.9,0,0,0-.5-1.1l-3.2-2h-.1l-3.1,1.8,3,5.2a.4.4,0,0,1,.1.3v.6a1.9,1.9,0,0,0,.5,1.1l-.4.7Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_483" data-name="XMLID 483">
                <path
                  id="XMLID_552"
                  data-name="XMLID 552"
                  class="cls-6"
                  d="M124.7,50.3s1.2-6.9,2.4-1l-2.3,2.1h.1l3,5.3h.3l3.2-1.9a.8.8,0,0,0,.2-.6V46.9s0-.1-.1,0l-3.4,2Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_487"
                  data-name="XMLID 487"
                  class="cls-6"
                  d="M128.1,57.2h-.2c-.2,0-.3-.2-.4-.3l-3.1-5.3-.3-.3.8-.8-.9.4v-.8c.4-2.5,1-3.8,1.8-3.8s1,.7,1.3,2.3l.7-.3,3.6-2.1h.3a.5.5,0,0,1,.2.4v7.5a1,1,0,0,1-.4.9L128.5,57A.4.4,0,0,1,128.1,57.2Zm-2.7-5.8,2.8,5,3.1-1.8v-7l-2.9,1.7-1.2.5Zm.6-4.1a11.1,11.1,0,0,0-.8,2.3l1.3-.6A3.2,3.2,0,0,0,126,47.3Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="XMLID_469" data-name="XMLID 469">
                <path
                  id="XMLID_480"
                  data-name="XMLID 480"
                  class="cls-7"
                  d="M127.5,56.9l-3.2-2a1.7,1.7,0,0,1-.7-1.4V45.9c0-.5.3-.8.7-.6l3.2,2a1.7,1.7,0,0,1,.7,1.4v7.6C128.2,56.9,127.9,57.1,127.5,56.9Z"
                  transform="translate(-0.5 -2.3)"
                />
                <path
                  id="XMLID_472"
                  data-name="XMLID 472"
                  class="cls-6"
                  d="M127.8,57.4h-.5l-3.2-2a2.3,2.3,0,0,1-.9-1.8V45.9a1.2,1.2,0,0,1,.5-1,1,1,0,0,1,.9,0l3.2,2a2.3,2.3,0,0,1,.9,1.8v7.6a1.2,1.2,0,0,1-.5,1Zm-.1-.9h0c.1,0,.1,0,.1-.2V48.7a1.9,1.9,0,0,0-.5-1.1l-3.2-2H124v7.8a1.9,1.9,0,0,0,.5,1.1Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
            </g>
            <g id="XMLID_459" data-name="XMLID 459">
              <path
                id="XMLID_462"
                data-name="XMLID 462"
                class="cls-6"
                d="M129.8,44.3l-3.3,2,.4.7,3.3-2Z"
                transform="translate(-0.5 -2.3)"
              />
            </g>
            <g id="XMLID_451" data-name="XMLID 451">
              <path
                id="XMLID_455"
                data-name="XMLID 455"
                class="cls-7"
                d="M131.3,50.6l-2.9,1.7.4.6,2.9-1.7Z"
                transform="translate(-0.5 -2.3)"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="SideTables">
        <g id="Group_14" data-name="Group 14">
          <g id="Group_15" data-name="Group 15">
            <path
              id="Vector_98"
              data-name="Vector 98"
              class="cls-2"
              d="M104.9,127.7l-8.7-5L96,64.3l8.8,5Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_16" data-name="Group 16">
            <path
              id="Vector_99"
              data-name="Vector 99"
              class="cls-2"
              d="M104.8,69.3l-8.8-5,7.7-4.5,8.7,5Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_17" data-name="Group 17">
            <path
              id="Vector_100"
              data-name="Vector 100"
              class="cls-8"
              d="M112.4,64.9l.2,58.5-7.7,4.4V69.4Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
        <g id="Group_18" data-name="Group 18">
          <g id="Group_19" data-name="Group 19">
            <path
              id="Vector_101"
              data-name="Vector 101"
              class="cls-2"
              d="M90.5,136.1,81.8,131V83.7l8.7,5Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_20" data-name="Group 20">
            <path
              id="Vector_102"
              data-name="Vector 102"
              class="cls-2"
              d="M90.4,88.8l-8.7-5,7.6-4.5,8.8,5Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_21" data-name="Group 21">
            <path
              id="Vector_103"
              data-name="Vector 103"
              class="cls-8"
              d="M98.1,84.4v47.4l-7.7,4.4V88.9Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
        <g id="Group_22" data-name="Group 22">
          <g id="Group_23" data-name="Group 23">
            <path
              id="Vector_104"
              data-name="Vector 104"
              class="cls-2"
              d="M76,144.5l-8.7-5v-20l8.7,5Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_24" data-name="Group 24">
            <path
              id="Vector_105"
              data-name="Vector 105"
              class="cls-2"
              d="M75.9,124.5l-8.7-5,7.7-4.5,8.7,5.2Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_25" data-name="Group 25">
            <path
              id="Vector_106"
              data-name="Vector 106"
              class="cls-8"
              d="M83.6,120.2v19.9L76,144.6v-20Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
        <g id="Group_26" data-name="Group 26">
          <g id="Group_27" data-name="Group 27">
            <path
              id="Vector_107"
              data-name="Vector 107"
              class="cls-2"
              d="M61.6,152.9l-8.8-5.2V111.2l8.8,5.2Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_28" data-name="Group 28">
            <path
              id="Vector_108"
              data-name="Vector 108"
              class="cls-2"
              d="M61.4,116.4l-8.8-5.2,7.7-4.4,8.7,5Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_29" data-name="Group 29">
            <path
              id="Vector_109"
              data-name="Vector 109"
              class="cls-8"
              d="M69,111.9v36.5l-7.6,4.5V116.4Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
        <g id="Group_30" data-name="Group 30">
          <g id="Group_31" data-name="Group 31">
            <path
              id="Vector_110"
              data-name="Vector 110"
              class="cls-2"
              d="M47.1,161.3l-8.8-5.2v-8.4l8.7,5.1Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_32" data-name="Group 32">
            <path
              id="Vector_111"
              data-name="Vector 111"
              class="cls-2"
              d="M47,152.8l-8.7-5.1,7.7-4.5,8.7,5.2Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_33" data-name="Group 33">
            <path
              id="Vector_112"
              data-name="Vector 112"
              class="cls-8"
              d="M54.7,148.4v8.4l-7.6,4.5v-8.5Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
      </g>
      <path
        id="Floating_ScreenFront"
        data-name="Floating ScreenFront"
        class="cls-9"
        d="M121.4,52v67.9a2.6,2.6,0,0,0,1.3,2.2l92.8,50.7a2.4,2.4,0,0,0,3.6-2.2V102.8a2.6,2.6,0,0,0-1.3-2.2L125,49.9A2.4,2.4,0,0,0,121.4,52Z"
        transform="translate(-0.5 -2.3)"
      />
      <g id="DogsGroup">
        <g class="cmsdots" id="Group_34" data-name="Group 34">
          <g id="Group_35" data-name="Group 35">
            <path
              id="Vector_113"
              data-name="Vector 113"
              class="cls-10"
              d="M50.2,177c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,50.2,177Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_36" data-name="Group 36">
            <path
              id="Vector_114"
              data-name="Vector 114"
              class="cls-2"
              d="M35.6,185.5c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,35.6,185.5Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_37" data-name="Group 37">
            <path
              id="Vector_115"
              data-name="Vector 115"
              class="cls-2"
              d="M21.1,193.8c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.8,5.8,0,0,1,21.1,193.8Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_38" data-name="Group 38">
            <path
              id="Vector_116"
              data-name="Vector 116"
              class="cls-10"
              d="M6.5,202.3c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,6.5,202.3Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_39" data-name="Group 39">
            <path
              id="Vector_117"
              data-name="Vector 117"
              class="cls-2"
              d="M64.7,185.4c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,64.7,185.4Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_40" data-name="Group 40">
            <path
              id="Vector_118"
              data-name="Vector 118"
              class="cls-2"
              d="M50.1,193.8c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A4.5,4.5,0,0,1,50.1,193.8Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_41" data-name="Group 41" class="cls-11">
            <path
              id="Vector_119"
              data-name="Vector 119"
              class="cls-10"
              d="M35.5,202.2c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,35.5,202.2Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_42" data-name="Group 42">
            <path
              id="Vector_120"
              data-name="Vector 120"
              class="cls-2"
              d="M21.1,210.7c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,21.1,210.7Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_43" data-name="Group 43">
            <path
              id="Vector_121"
              data-name="Vector 121"
              class="cls-2"
              d="M79.1,193.7c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,79.1,193.7Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_44" data-name="Group 44">
            <path
              id="Vector_122"
              data-name="Vector 122"
              class="cls-2"
              d="M64.5,202.1c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,64.5,202.1Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_45" data-name="Group 45">
            <path
              id="Vector_123"
              data-name="Vector 123"
              class="cls-2"
              d="M50,210.6c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,50,210.6Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_46" data-name="Group 46">
            <path
              id="Vector_124"
              data-name="Vector 124"
              class="cls-2"
              d="M35.5,219.1c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A4.5,4.5,0,0,1,35.5,219.1Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_47" data-name="Group 47">
            <path
              id="Vector_125"
              data-name="Vector 125"
              class="cls-2"
              d="M93.6,202.1c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A4.5,4.5,0,0,1,93.6,202.1Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_48" data-name="Group 48" class="cls-11">
            <path
              id="Vector_126"
              data-name="Vector 126"
              class="cls-10"
              d="M79,210.5c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,79,210.5Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_49" data-name="Group 49">
            <path
              id="Vector_127"
              data-name="Vector 127"
              class="cls-2"
              d="M64.4,219c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,64.4,219Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_50" data-name="Group 50">
            <path
              id="Vector_128"
              data-name="Vector 128"
              class="cls-2"
              d="M50,227.4c1.3.7,1.3,1.8,0,2.5a5.1,5.1,0,0,1-4.5,0c-1.3-.7-1.3-1.8,0-2.5A5.1,5.1,0,0,1,50,227.4Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
      </g>
      <g id="LinesonSide">
        <path
          id="Vector_129"
          data-name="Vector 129"
          class="cls-12"
          d="M208.1,259.3l-1.1-.6,5.1-9.2,4.4,1.4,3.2-4.4,3.4-10,7-12.2,5.7,7.1,5.1-5.4,5.5,2.1,5.1-10,8.6-5.3,7.6-14.2,7.9,3.9,4.8-9.1,1.3.7-5.5,10.1-7.9-3.9-7.1,13.5-8.7,5.2-5.4,10.8-5.7-2.2-5.4,5.9-5.5-6.8L224.4,237,221,247.1l-3.8,5.2L213,251Z"
          transform="translate(-0.5 -2.3)"
        />
        <g id="Group_51" data-name="Group 51">
          <g id="Group_52" data-name="Group 52">
            <path
              id="Vector_130"
              data-name="Vector 130"
              class="cls-12"
              d="M216.7,248.7c1.3-.8,2.3-.1,2.4,1.4a4.9,4.9,0,0,1-2.3,4c-1.3.7-2.3.1-2.3-1.4A4.2,4.2,0,0,1,216.7,248.7Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_53" data-name="Group 53">
            <path
              id="Vector_131"
              data-name="Vector 131"
              class="cls-12"
              d="M216.7,250.1c.6-.3,1-.1,1,.6a2.4,2.4,0,0,1-1,1.8c-.6.3-1,.1-1-.6A2.1,2.1,0,0,1,216.7,250.1Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
        <g id="Group_54" data-name="Group 54">
          <g id="Group_55" data-name="Group 55">
            <path
              id="Vector_132"
              data-name="Vector 132"
              class="cls-12"
              d="M230.3,215.8c1.3-.8,2.3,7,2.4,8.5a4.9,4.9,0,0,1-2.3,4c-1.3.8-2.3.1-2.3-1.4S228.9,216.6,230.3,215.8Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_56" data-name="Group 56">
            <path
              id="Vector_133"
              data-name="Vector 133"
              class="cls-12"
              d="M230.3,224.4c.6-.3,1-.1,1,.6a2.4,2.4,0,0,1-1,1.8c-.6.3-1,.1-1-.6A1.7,1.7,0,0,1,230.3,224.4Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
        <g id="Group_57" data-name="Group 57">
          <g id="Group_58" data-name="Group 58">
            <path
              id="Vector_134"
              data-name="Vector 134"
              class="cls-12"
              d="M260.9,210.1c1.3-.8,2.4-.1,2.4,1.4a4.9,4.9,0,0,1-2.3,4c-1.3.8-2.3.1-2.3-1.4A5,5,0,0,1,260.9,210.1Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_59" data-name="Group 59">
            <path
              id="Vector_135"
              data-name="Vector 135"
              class="cls-12"
              d="M260.9,211.6c.6-.3,1-.1,1,.6a2.4,2.4,0,0,1-1,1.8c-.6.3-1,.1-1-.6A2.4,2.4,0,0,1,260.9,211.6Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
        <g id="Group_60" data-name="Group 60">
          <g id="Group_61" data-name="Group 61">
            <path
              id="Vector_136"
              data-name="Vector 136"
              class="cls-12"
              d="M280.4,191.9c1.3-.8,2.3-.1,2.4,1.4a4.9,4.9,0,0,1-2.3,4c-1.3.8-2.3.1-2.3-1.4A4.6,4.6,0,0,1,280.4,191.9Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group_62" data-name="Group 62">
            <path
              id="Vector_137"
              data-name="Vector 137"
              class="cls-12"
              d="M280.4,193.4c.6-.3,1-.1,1,.6a2.4,2.4,0,0,1-1,1.8c-.6.3-1,.1-1-.6A2.1,2.1,0,0,1,280.4,193.4Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
      </g>
      <g id="TransparentScreens">
        <path
          id="Vector_138"
          data-name="Vector 138"
          class="cls-13"
          d="M207.9,222.6V198a1,1,0,0,1,.5-.8l33.7-18.5a.9.9,0,0,1,1.3.8v24.7a1,1,0,0,1-.5.8l-33.7,18.5A1,1,0,0,1,207.9,222.6Z"
          transform="translate(-0.5 -2.3)"
        />
        <path
          id="Vector_139"
          data-name="Vector 139"
          class="cls-13"
          d="M230.9,197.5V171.7a.9.9,0,0,1,.5-.8l35.3-19.3a1,1,0,0,1,1.4.8v25.8a.9.9,0,0,1-.5.8l-35.3,19.3A.9.9,0,0,1,230.9,197.5Z"
          transform="translate(-0.5 -2.3)"
        />
        <g id="ScreenThingys">
          <g id="Group0404">
            <path
              id="Vector_140"
              data-name="Vector 140"
              class="cls-12"
              d="M219,211.4v-.7a.5.5,0,0,0-.8-.5l-3.4,2c-.2.1-.2.2-.2.5v.7a.5.5,0,0,0,.8.5l3.4-2C218.9,211.9,219,211.6,219,211.4Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group0303">
            <path
              id="Vector_141"
              data-name="Vector 141"
              class="cls-12"
              d="M230,201.5v-.7a.5.5,0,0,0-.8-.5l-14.5,8.3c-.2.1-.2.2-.2.5v.7a.5.5,0,0,0,.8.5l14.5-8.3A.6.6,0,0,0,230,201.5Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group0202" class="cls-14">
            <path
              id="Vector_142"
              data-name="Vector 142"
              class="cls-15"
              d="M224.1,197.6v-.7a.5.5,0,0,0-.8-.5l-8.5,4.8c-.2.1-.2.2-.2.5v.7a.5.5,0,0,0,.8.5l8.5-4.8C223.9,198,224.1,197.9,224.1,197.6Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
          <g id="Group0101">
            <path
              id="Vector_143"
              data-name="Vector 143"
              class="cls-16"
              d="M227.7,199.1v-.7a.5.5,0,0,0-.8-.5l-12.2,7c-.2.1-.2.2-.2.5v.7a.5.5,0,0,0,.8.5l12.2-7A.6.6,0,0,0,227.7,199.1Z"
              transform="translate(-0.5 -2.3)"
            />
          </g>
        </g>
      </g>
      <g id="Round_Element" data-name="Round Element">
        <g id="Group02">
          <path
            id="Vector_144"
            data-name="Vector 144"
            class="cls-2"
            d="M149.5,241.5c12.6,7.3,12.7,19.2.1,26.5s-33.1,7.3-45.7,0-12.7-19.2-.1-26.5S136.8,234.1,149.5,241.5Z"
            transform="translate(-0.5 -2.3)"
          />
        </g>
        <g id="Roundy">
          <g id="Group_63" data-name="Group 63">
            <g id="Group_64" data-name="Group 64">
              <path
                id="Vector_145"
                data-name="Vector 145"
                class="cls-12"
                d="M144.1,255c-.1,2.6-2,4.7-4,6.1a23,23,0,0,1-8.5,3.2c-5.9.9-12.7.3-17.8-3-2.3-1.5-4.4-3.8-4.4-6.7a10.8,10.8,0,0,0,0,1.8c.1,4.7,5.2,7.5,9.1,8.7a28.3,28.3,0,0,0,15,.5c4-1,9.3-3.3,10.4-7.8a16.2,16.2,0,0,0,.2-3.8v1Z"
                transform="translate(-0.5 -2.3)"
              />
              <g id="Group_65" data-name="Group 65">
                <path
                  id="Vector_146"
                  data-name="Vector 146"
                  class="cls-12"
                  d="M139,247.6c6.8,3.9,6.9,10.3.1,14.2s-17.8,3.9-24.6,0-6.9-10.3-.1-14.2S132.1,243.7,139,247.6Zm-22.2,12.8c5.5,3.2,14.5,3.2,20,0s5.5-8.4-.1-11.6-14.5-3.2-20,0S111.3,257.3,116.8,260.4Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
              <g id="Group_66" data-name="Group 66">
                <path
                  id="Vector_147"
                  data-name="Vector 147"
                  class="cls-2"
                  d="M139,247.6c6.8,3.9,6.9,10.3.1,14.2s-17.8,3.9-24.6,0-6.9-10.3-.1-14.2S132.1,243.7,139,247.6Z"
                  transform="translate(-0.5 -2.3)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g id="Mini_Dots" data-name="Mini Dots">
      <g id="Group_67" data-name="Group 67">
        <path
          id="Vector_148"
          data-name="Vector 148"
          class="cls-2"
          d="M334.9,67.4a3.9,3.9,0,0,1,1.7,3c0,1.2-.8,1.5-1.7,1a3.9,3.9,0,0,1-1.7-3C333.2,67.2,334,66.8,334.9,67.4Z"
          transform="translate(-0.5 -2.3)"
        />
      </g>
      <g id="Group_68" data-name="Group 68">
        <path
          id="Vector_149"
          data-name="Vector 149"
          class="cls-2"
          d="M178.6,16.2a8.1,8.1,0,0,1,3.8,6.5c0,2.4-1.7,3.3-3.8,2.2a8.1,8.1,0,0,1-3.8-6.5C174.8,16,176.6,14.9,178.6,16.2Z"
          transform="translate(-0.5 -2.3)"
        />
      </g>
      <g id="Group_69" data-name="Group 69">
        <path
          id="Vector_150"
          data-name="Vector 150"
          class="cls-2"
          d="M244.4,56.1a3.9,3.9,0,0,1,1.7,3c0,1.1-.8,1.5-1.7,1a3.9,3.9,0,0,1-1.7-3C242.7,56.1,243.5,55.7,244.4,56.1Z"
          transform="translate(-0.5 -2.3)"
        />
      </g>
      <g id="Group_70" data-name="Group 70">
        <path
          id="Vector_151"
          data-name="Vector 151"
          class="cls-2"
          d="M281.1,134.5a3.9,3.9,0,0,1,1.7,3c0,1.1-.8,1.5-1.7,1a3.9,3.9,0,0,1-1.7-3C279.4,134.4,280.2,133.9,281.1,134.5Z"
          transform="translate(-0.5 -2.3)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState([
      "toggleConfig",
      "startConfig",
      "isAnimationDisabled",
      "viewportSize",
    ]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    cmsAnim() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-netlifycms",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 0.5,
            stagger: 0.05,
            ease: "sine",
          },
        })
        .add("cms")
        .from("#SideTables g", {
          scaleY: 0,
          transformOrigin: "100% 50%",
        })
        .from(
          "#FrontElements g",
          {
            stagger: 0.01,
            scale: 0,
            transformOrigin: "50% 50%",
          },
          "cms"
        )
        .from(
          ".cmsdots g",
          {
            opacity: 0,
          },
          "cms"
        )
        .from(
          "#drawnlinescms",
          {
            duration: 1.5,
            opacity: 0,
          },
          "cms"
        );
    },
  },
  mounted() {
    this.cmsAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1,
.cls-5 {
  fill: none;
}

.cls-1 {
  stroke: #fcfcfc;
  stroke-miterlimit: 10;
  stroke-width: 2px;
}

.cls-10,
.cls-2,
.cls-7 {
  fill: #ffad43;
}

.cls-10,
.cls-12,
.cls-13,
.cls-15,
.cls-16,
.cls-2,
.cls-5,
.cls-8,
.cls-9 {
  stroke: #000;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.15px;
}

.cls-3 {
  opacity: 0.64;
}

.cls-12,
.cls-13,
.cls-15,
.cls-16,
.cls-4,
.cls-9 {
  fill: #fff;
}

.cls-6,
.cls-8 {
  fill: #0e1e25;
}

.cls-9 {
  opacity: 0.5;
}

.cls-10,
.cls-13,
.cls-15,
.cls-16,
.cls-9 {
  isolation: isolate;
}

.cls-10,
.cls-11 {
  opacity: 0.74;
}

.cls-13 {
  opacity: 0.81;
}

.cls-14,
.cls-15 {
  opacity: 0.53;
}

.cls-16 {
  opacity: 0.3;
}
</style>
